import { Icon } from "@chakra-ui/react";
import { forwardRef } from "react";
import { jsx, jsxs } from "react/jsx-runtime";
// src/icons/components/ArchiveIcon.tsx
const ArchiveIcon = forwardRef((props, ref) => {
	return /* @__PURE__ */ jsx(Icon, {
		...props,
		ref,
		children: /* @__PURE__ */ jsxs("svg", {
			xmlns: "http://www.w3.org/2000/svg",
			width: "24",
			height: "24",
			viewBox: "0 0 24 24",
			fill: "none",
			stroke: "currentColor",
			strokeWidth: "2",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			children: [
				/* @__PURE__ */ jsx("rect", {
					width: "20",
					height: "5",
					x: "2",
					y: "3",
					rx: "1"
				}),
				/* @__PURE__ */ jsx("path", { d: "M4 8v11a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8" }),
				/* @__PURE__ */ jsx("path", { d: "M10 12h4" })
			]
		})
	});
});
ArchiveIcon.displayName = "ArchiveIcon";
// src/icons/components/ArrowLeftToLineIcon.tsx
const ArrowLeftToLineIcon = forwardRef((props, ref) => {
	return /* @__PURE__ */ jsx(Icon, {
		...props,
		ref,
		children: /* @__PURE__ */ jsxs("svg", {
			xmlns: "http://www.w3.org/2000/svg",
			width: "24",
			height: "24",
			viewBox: "0 0 24 24",
			fill: "none",
			stroke: "currentColor",
			strokeWidth: "2",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			children: [
				/* @__PURE__ */ jsx("path", { d: "M3 19V5" }),
				/* @__PURE__ */ jsx("path", { d: "m13 6-6 6 6 6" }),
				/* @__PURE__ */ jsx("path", { d: "M7 12h14" })
			]
		})
	});
});
ArrowLeftToLineIcon.displayName = "ArrowLeftToLineIcon";
// src/icons/components/ArrowRightToLineIcon.tsx
const ArrowRightToLineIcon = forwardRef((props, ref) => {
	return /* @__PURE__ */ jsx(Icon, {
		...props,
		ref,
		children: /* @__PURE__ */ jsxs("svg", {
			xmlns: "http://www.w3.org/2000/svg",
			width: "24",
			height: "24",
			viewBox: "0 0 24 24",
			fill: "none",
			stroke: "currentColor",
			strokeWidth: "2",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			children: [
				/* @__PURE__ */ jsx("path", { d: "M17 12H3" }),
				/* @__PURE__ */ jsx("path", { d: "m11 18 6-6-6-6" }),
				/* @__PURE__ */ jsx("path", { d: "M21 5v14" })
			]
		})
	});
});
ArrowRightToLineIcon.displayName = "ArrowRightToLineIcon";
// src/icons/components/BadgeEuroIcon.tsx
const BadgeEuroIcon = forwardRef((props, ref) => {
	return /* @__PURE__ */ jsx(Icon, {
		...props,
		ref,
		children: /* @__PURE__ */ jsxs("svg", {
			xmlns: "http://www.w3.org/2000/svg",
			width: "24",
			height: "24",
			viewBox: "0 0 24 24",
			fill: "none",
			stroke: "currentColor",
			strokeWidth: "2",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			children: [
				/* @__PURE__ */ jsx("path", { d: "M3.85 8.62a4 4 0 0 1 4.78-4.77 4 4 0 0 1 6.74 0 4 4 0 0 1 4.78 4.78 4 4 0 0 1 0 6.74 4 4 0 0 1-4.77 4.78 4 4 0 0 1-6.75 0 4 4 0 0 1-4.78-4.77 4 4 0 0 1 0-6.76Z" }),
				/* @__PURE__ */ jsx("path", { d: "M7 12h5" }),
				/* @__PURE__ */ jsx("path", { d: "M15 9.4a4 4 0 1 0 0 5.2" })
			]
		})
	});
});
BadgeEuroIcon.displayName = "BadgeEuroIcon";
// src/icons/components/BellIcon.tsx
const BellIcon = forwardRef((props, ref) => {
	return /* @__PURE__ */ jsx(Icon, {
		...props,
		ref,
		children: /* @__PURE__ */ jsxs("svg", {
			xmlns: "http://www.w3.org/2000/svg",
			width: "24",
			height: "24",
			viewBox: "0 0 24 24",
			fill: "none",
			stroke: "currentColor",
			strokeWidth: "2",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			children: [/* @__PURE__ */ jsx("path", { d: "M10.268 21a2 2 0 0 0 3.464 0" }), /* @__PURE__ */ jsx("path", { d: "M3.262 15.326A1 1 0 0 0 4 17h16a1 1 0 0 0 .74-1.673C19.41 13.956 18 12.499 18 8A6 6 0 0 0 6 8c0 4.499-1.411 5.956-2.738 7.326" })]
		})
	});
});
BellIcon.displayName = "BellIcon";
// src/icons/components/BlocksIcon.tsx
const BlocksIcon = forwardRef((props, ref) => {
	return /* @__PURE__ */ jsx(Icon, {
		...props,
		ref,
		children: /* @__PURE__ */ jsxs("svg", {
			xmlns: "http://www.w3.org/2000/svg",
			width: "24",
			height: "24",
			viewBox: "0 0 24 24",
			fill: "none",
			stroke: "currentColor",
			strokeWidth: "2",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			children: [/* @__PURE__ */ jsx("path", { d: "M10 22V7a1 1 0 0 0-1-1H4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-5a1 1 0 0 0-1-1H2" }), /* @__PURE__ */ jsx("rect", {
				x: "14",
				y: "2",
				width: "8",
				height: "8",
				rx: "1"
			})]
		})
	});
});
BlocksIcon.displayName = "BlocksIcon";
// src/icons/components/BookAIcon.tsx
const BookAIcon = forwardRef((props, ref) => {
	return /* @__PURE__ */ jsx(Icon, {
		...props,
		ref,
		children: /* @__PURE__ */ jsxs("svg", {
			xmlns: "http://www.w3.org/2000/svg",
			width: "24",
			height: "24",
			viewBox: "0 0 24 24",
			fill: "none",
			stroke: "currentColor",
			strokeWidth: "2",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			children: [
				/* @__PURE__ */ jsx("path", { d: "M4 19.5v-15A2.5 2.5 0 0 1 6.5 2H19a1 1 0 0 1 1 1v18a1 1 0 0 1-1 1H6.5a1 1 0 0 1 0-5H20" }),
				/* @__PURE__ */ jsx("path", { d: "m8 13 4-7 4 7" }),
				/* @__PURE__ */ jsx("path", { d: "M9.1 11h5.7" })
			]
		})
	});
});
BookAIcon.displayName = "BookAIcon";
// src/icons/components/BookImageIcon.tsx
const BookImageIcon = forwardRef((props, ref) => {
	return /* @__PURE__ */ jsx(Icon, {
		...props,
		ref,
		children: /* @__PURE__ */ jsxs("svg", {
			xmlns: "http://www.w3.org/2000/svg",
			width: "24",
			height: "24",
			viewBox: "0 0 24 24",
			fill: "none",
			stroke: "currentColor",
			strokeWidth: "2",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			children: [
				/* @__PURE__ */ jsx("path", { d: "m20 13.7-2.1-2.1a2 2 0 0 0-2.8 0L9.7 17" }),
				/* @__PURE__ */ jsx("path", { d: "M4 19.5v-15A2.5 2.5 0 0 1 6.5 2H19a1 1 0 0 1 1 1v18a1 1 0 0 1-1 1H6.5a1 1 0 0 1 0-5H20" }),
				/* @__PURE__ */ jsx("circle", {
					cx: "10",
					cy: "8",
					r: "2"
				})
			]
		})
	});
});
BookImageIcon.displayName = "BookImageIcon";
// src/icons/components/BookOpenIcon.tsx
const BookOpenIcon = forwardRef((props, ref) => {
	return /* @__PURE__ */ jsx(Icon, {
		...props,
		ref,
		children: /* @__PURE__ */ jsxs("svg", {
			xmlns: "http://www.w3.org/2000/svg",
			width: "24",
			height: "24",
			viewBox: "0 0 24 24",
			fill: "none",
			stroke: "currentColor",
			strokeWidth: "2",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			children: [/* @__PURE__ */ jsx("path", { d: "M12 7v14" }), /* @__PURE__ */ jsx("path", { d: "M3 18a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1h5a4 4 0 0 1 4 4 4 4 0 0 1 4-4h5a1 1 0 0 1 1 1v13a1 1 0 0 1-1 1h-6a3 3 0 0 0-3 3 3 3 0 0 0-3-3z" })]
		})
	});
});
BookOpenIcon.displayName = "BookOpenIcon";
// src/icons/components/BriefcaseBusinessIcon.tsx
const BriefcaseBusinessIcon = forwardRef((props, ref) => {
	return /* @__PURE__ */ jsx(Icon, {
		...props,
		ref,
		children: /* @__PURE__ */ jsxs("svg", {
			xmlns: "http://www.w3.org/2000/svg",
			width: "24",
			height: "24",
			viewBox: "0 0 24 24",
			fill: "none",
			stroke: "currentColor",
			strokeWidth: "2",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			children: [
				/* @__PURE__ */ jsx("path", { d: "M12 12h.01" }),
				/* @__PURE__ */ jsx("path", { d: "M16 6V4a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v2" }),
				/* @__PURE__ */ jsx("path", { d: "M22 13a18.15 18.15 0 0 1-20 0" }),
				/* @__PURE__ */ jsx("rect", {
					width: "20",
					height: "14",
					x: "2",
					y: "6",
					rx: "2"
				})
			]
		})
	});
});
BriefcaseBusinessIcon.displayName = "BriefcaseBusinessIcon";
// src/icons/components/Calendar1Icon.tsx
const Calendar1Icon = forwardRef((props, ref) => {
	return /* @__PURE__ */ jsx(Icon, {
		...props,
		ref,
		children: /* @__PURE__ */ jsxs("svg", {
			xmlns: "http://www.w3.org/2000/svg",
			width: "24",
			height: "24",
			viewBox: "0 0 24 24",
			fill: "none",
			stroke: "currentColor",
			strokeWidth: "2",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			children: [
				/* @__PURE__ */ jsx("path", { d: "M11 14h1v4" }),
				/* @__PURE__ */ jsx("path", { d: "M16 2v4" }),
				/* @__PURE__ */ jsx("path", { d: "M3 10h18" }),
				/* @__PURE__ */ jsx("path", { d: "M8 2v4" }),
				/* @__PURE__ */ jsx("rect", {
					x: "3",
					y: "4",
					width: "18",
					height: "18",
					rx: "2"
				})
			]
		})
	});
});
Calendar1Icon.displayName = "Calendar1Icon";
// src/icons/components/CalendarDaysIcon.tsx
const CalendarDaysIcon = forwardRef((props, ref) => {
	return /* @__PURE__ */ jsx(Icon, {
		...props,
		ref,
		children: /* @__PURE__ */ jsxs("svg", {
			xmlns: "http://www.w3.org/2000/svg",
			width: "24",
			height: "24",
			viewBox: "0 0 24 24",
			fill: "none",
			stroke: "currentColor",
			strokeWidth: "2",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			children: [
				/* @__PURE__ */ jsx("path", { d: "M8 2v4" }),
				/* @__PURE__ */ jsx("path", { d: "M16 2v4" }),
				/* @__PURE__ */ jsx("rect", {
					width: "18",
					height: "18",
					x: "3",
					y: "4",
					rx: "2"
				}),
				/* @__PURE__ */ jsx("path", { d: "M3 10h18" }),
				/* @__PURE__ */ jsx("path", { d: "M8 14h.01" }),
				/* @__PURE__ */ jsx("path", { d: "M12 14h.01" }),
				/* @__PURE__ */ jsx("path", { d: "M16 14h.01" }),
				/* @__PURE__ */ jsx("path", { d: "M8 18h.01" }),
				/* @__PURE__ */ jsx("path", { d: "M12 18h.01" }),
				/* @__PURE__ */ jsx("path", { d: "M16 18h.01" })
			]
		})
	});
});
CalendarDaysIcon.displayName = "CalendarDaysIcon";
// src/icons/components/ChartColumnIncreasingIcon.tsx
const ChartColumnIncreasingIcon = forwardRef((props, ref) => {
	return /* @__PURE__ */ jsx(Icon, {
		...props,
		ref,
		children: /* @__PURE__ */ jsxs("svg", {
			xmlns: "http://www.w3.org/2000/svg",
			width: "24",
			height: "24",
			viewBox: "0 0 24 24",
			fill: "none",
			stroke: "currentColor",
			strokeWidth: "2",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			children: [
				/* @__PURE__ */ jsx("path", { d: "M13 17V9" }),
				/* @__PURE__ */ jsx("path", { d: "M18 17V5" }),
				/* @__PURE__ */ jsx("path", { d: "M3 3v16a2 2 0 0 0 2 2h16" }),
				/* @__PURE__ */ jsx("path", { d: "M8 17v-3" })
			]
		})
	});
});
ChartColumnIncreasingIcon.displayName = "ChartColumnIncreasingIcon";
// src/icons/components/ChartSplineIcon.tsx
const ChartSplineIcon = forwardRef((props, ref) => {
	return /* @__PURE__ */ jsx(Icon, {
		...props,
		ref,
		children: /* @__PURE__ */ jsxs("svg", {
			xmlns: "http://www.w3.org/2000/svg",
			width: "24",
			height: "24",
			viewBox: "0 0 24 24",
			fill: "none",
			stroke: "currentColor",
			strokeWidth: "2",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			children: [/* @__PURE__ */ jsx("path", { d: "M3 3v16a2 2 0 0 0 2 2h16" }), /* @__PURE__ */ jsx("path", { d: "M7 16c.5-2 1.5-7 4-7 2 0 2 3 4 3 2.5 0 4.5-5 5-7" })]
		})
	});
});
ChartSplineIcon.displayName = "ChartSplineIcon";
// src/icons/components/CheckIcon.tsx
const CheckIcon = forwardRef((props, ref) => {
	return /* @__PURE__ */ jsx(Icon, {
		...props,
		ref,
		children: /* @__PURE__ */ jsx("svg", {
			xmlns: "http://www.w3.org/2000/svg",
			width: "24",
			height: "24",
			viewBox: "0 0 24 24",
			fill: "none",
			stroke: "currentColor",
			strokeWidth: "2",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			children: /* @__PURE__ */ jsx("path", { d: "M20 6 9 17l-5-5" })
		})
	});
});
CheckIcon.displayName = "CheckIcon";
// src/icons/components/ChevronDownIcon.tsx
const ChevronDownIcon = forwardRef((props, ref) => {
	return /* @__PURE__ */ jsx(Icon, {
		...props,
		ref,
		children: /* @__PURE__ */ jsx("svg", {
			xmlns: "http://www.w3.org/2000/svg",
			width: "24",
			height: "24",
			viewBox: "0 0 24 24",
			fill: "none",
			stroke: "currentColor",
			strokeWidth: "2",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			children: /* @__PURE__ */ jsx("path", { d: "m6 9 6 6 6-6" })
		})
	});
});
ChevronDownIcon.displayName = "ChevronDownIcon";
// src/icons/components/ChevronLeftIcon.tsx
const ChevronLeftIcon = forwardRef((props, ref) => {
	return /* @__PURE__ */ jsx(Icon, {
		...props,
		ref,
		children: /* @__PURE__ */ jsx("svg", {
			xmlns: "http://www.w3.org/2000/svg",
			width: "24",
			height: "24",
			viewBox: "0 0 24 24",
			fill: "none",
			stroke: "currentColor",
			strokeWidth: "2",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			children: /* @__PURE__ */ jsx("path", { d: "m15 18-6-6 6-6" })
		})
	});
});
ChevronLeftIcon.displayName = "ChevronLeftIcon";
// src/icons/components/ChevronRightIcon.tsx
const ChevronRightIcon = forwardRef((props, ref) => {
	return /* @__PURE__ */ jsx(Icon, {
		...props,
		ref,
		children: /* @__PURE__ */ jsx("svg", {
			xmlns: "http://www.w3.org/2000/svg",
			width: "24",
			height: "24",
			viewBox: "0 0 24 24",
			fill: "none",
			stroke: "currentColor",
			strokeWidth: "2",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			children: /* @__PURE__ */ jsx("path", { d: "m9 18 6-6-6-6" })
		})
	});
});
ChevronRightIcon.displayName = "ChevronRightIcon";
// src/icons/components/ChevronsLeftIcon.tsx
const ChevronsLeftIcon = forwardRef((props, ref) => {
	return /* @__PURE__ */ jsx(Icon, {
		...props,
		ref,
		children: /* @__PURE__ */ jsxs("svg", {
			xmlns: "http://www.w3.org/2000/svg",
			width: "24",
			height: "24",
			viewBox: "0 0 24 24",
			fill: "none",
			stroke: "currentColor",
			strokeWidth: "2",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			children: [/* @__PURE__ */ jsx("path", { d: "m11 17-5-5 5-5" }), /* @__PURE__ */ jsx("path", { d: "m18 17-5-5 5-5" })]
		})
	});
});
ChevronsLeftIcon.displayName = "ChevronsLeftIcon";
// src/icons/components/ChevronsRightIcon.tsx
const ChevronsRightIcon = forwardRef((props, ref) => {
	return /* @__PURE__ */ jsx(Icon, {
		...props,
		ref,
		children: /* @__PURE__ */ jsxs("svg", {
			xmlns: "http://www.w3.org/2000/svg",
			width: "24",
			height: "24",
			viewBox: "0 0 24 24",
			fill: "none",
			stroke: "currentColor",
			strokeWidth: "2",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			children: [/* @__PURE__ */ jsx("path", { d: "m6 17 5-5-5-5" }), /* @__PURE__ */ jsx("path", { d: "m13 17 5-5-5-5" })]
		})
	});
});
ChevronsRightIcon.displayName = "ChevronsRightIcon";
// src/icons/components/ChevronUpIcon.tsx
const ChevronUpIcon = forwardRef((props, ref) => {
	return /* @__PURE__ */ jsx(Icon, {
		...props,
		ref,
		children: /* @__PURE__ */ jsx("svg", {
			xmlns: "http://www.w3.org/2000/svg",
			width: "24",
			height: "24",
			viewBox: "0 0 24 24",
			fill: "none",
			stroke: "currentColor",
			strokeWidth: "2",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			children: /* @__PURE__ */ jsx("path", { d: "m18 15-6-6-6 6" })
		})
	});
});
ChevronUpIcon.displayName = "ChevronUpIcon";
// src/icons/components/CircleCheckIcon.tsx
const CircleCheckIcon = forwardRef((props, ref) => {
	return /* @__PURE__ */ jsx(Icon, {
		...props,
		ref,
		children: /* @__PURE__ */ jsxs("svg", {
			xmlns: "http://www.w3.org/2000/svg",
			width: "24",
			height: "24",
			viewBox: "0 0 24 24",
			fill: "none",
			stroke: "currentColor",
			strokeWidth: "2",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			children: [/* @__PURE__ */ jsx("circle", {
				cx: "12",
				cy: "12",
				r: "10"
			}), /* @__PURE__ */ jsx("path", { d: "m9 12 2 2 4-4" })]
		})
	});
});
CircleCheckIcon.displayName = "CircleCheckIcon";
// src/icons/components/CircleOffIcon.tsx
const CircleOffIcon = forwardRef((props, ref) => {
	return /* @__PURE__ */ jsx(Icon, {
		...props,
		ref,
		children: /* @__PURE__ */ jsxs("svg", {
			xmlns: "http://www.w3.org/2000/svg",
			width: "24",
			height: "24",
			viewBox: "0 0 24 24",
			fill: "none",
			stroke: "currentColor",
			strokeWidth: "2",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			children: [
				/* @__PURE__ */ jsx("path", { d: "m2 2 20 20" }),
				/* @__PURE__ */ jsx("path", { d: "M8.35 2.69A10 10 0 0 1 21.3 15.65" }),
				/* @__PURE__ */ jsx("path", { d: "M19.08 19.08A10 10 0 1 1 4.92 4.92" })
			]
		})
	});
});
CircleOffIcon.displayName = "CircleOffIcon";
// src/icons/components/CircleQuestionMarkIcon.tsx
const CircleQuestionMarkIcon = forwardRef((props, ref) => {
	return /* @__PURE__ */ jsx(Icon, {
		...props,
		ref,
		children: /* @__PURE__ */ jsxs("svg", {
			xmlns: "http://www.w3.org/2000/svg",
			width: "24",
			height: "24",
			viewBox: "0 0 24 24",
			fill: "none",
			stroke: "currentColor",
			strokeWidth: "2",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			children: [
				/* @__PURE__ */ jsx("circle", {
					cx: "12",
					cy: "12",
					r: "10"
				}),
				/* @__PURE__ */ jsx("path", { d: "M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3" }),
				/* @__PURE__ */ jsx("path", { d: "M12 17h.01" })
			]
		})
	});
});
CircleQuestionMarkIcon.displayName = "CircleQuestionMarkIcon";
// src/icons/components/CircleUserIcon.tsx
const CircleUserIcon = forwardRef((props, ref) => {
	return /* @__PURE__ */ jsx(Icon, {
		...props,
		ref,
		children: /* @__PURE__ */ jsxs("svg", {
			xmlns: "http://www.w3.org/2000/svg",
			width: "24",
			height: "24",
			viewBox: "0 0 24 24",
			fill: "none",
			stroke: "currentColor",
			strokeWidth: "2",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			children: [
				/* @__PURE__ */ jsx("circle", {
					cx: "12",
					cy: "12",
					r: "10"
				}),
				/* @__PURE__ */ jsx("circle", {
					cx: "12",
					cy: "10",
					r: "3"
				}),
				/* @__PURE__ */ jsx("path", { d: "M7 20.662V19a2 2 0 0 1 2-2h6a2 2 0 0 1 2 2v1.662" })
			]
		})
	});
});
CircleUserIcon.displayName = "CircleUserIcon";
// src/icons/components/CircleXIcon.tsx
const CircleXIcon = forwardRef((props, ref) => {
	return /* @__PURE__ */ jsx(Icon, {
		...props,
		ref,
		children: /* @__PURE__ */ jsxs("svg", {
			xmlns: "http://www.w3.org/2000/svg",
			width: "24",
			height: "24",
			viewBox: "0 0 24 24",
			fill: "none",
			stroke: "currentColor",
			strokeWidth: "2",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			children: [
				/* @__PURE__ */ jsx("circle", {
					cx: "12",
					cy: "12",
					r: "10"
				}),
				/* @__PURE__ */ jsx("path", { d: "m15 9-6 6" }),
				/* @__PURE__ */ jsx("path", { d: "m9 9 6 6" })
			]
		})
	});
});
CircleXIcon.displayName = "CircleXIcon";
// src/icons/components/ClockIcon.tsx
const ClockIcon = forwardRef((props, ref) => {
	return /* @__PURE__ */ jsx(Icon, {
		...props,
		ref,
		children: /* @__PURE__ */ jsxs("svg", {
			xmlns: "http://www.w3.org/2000/svg",
			width: "24",
			height: "24",
			viewBox: "0 0 24 24",
			fill: "none",
			stroke: "currentColor",
			strokeWidth: "2",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			children: [/* @__PURE__ */ jsx("circle", {
				cx: "12",
				cy: "12",
				r: "10"
			}), /* @__PURE__ */ jsx("path", { d: "M12 6v6l4 2" })]
		})
	});
});
ClockIcon.displayName = "ClockIcon";
// src/icons/components/CopyIcon.tsx
const CopyIcon = forwardRef((props, ref) => {
	return /* @__PURE__ */ jsx(Icon, {
		...props,
		ref,
		children: /* @__PURE__ */ jsxs("svg", {
			xmlns: "http://www.w3.org/2000/svg",
			width: "24",
			height: "24",
			viewBox: "0 0 24 24",
			fill: "none",
			stroke: "currentColor",
			strokeWidth: "2",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			children: [/* @__PURE__ */ jsx("rect", {
				width: "14",
				height: "14",
				x: "8",
				y: "8",
				rx: "2",
				ry: "2"
			}), /* @__PURE__ */ jsx("path", { d: "M4 16c-1.1 0-2-.9-2-2V4c0-1.1.9-2 2-2h10c1.1 0 2 .9 2 2" })]
		})
	});
});
CopyIcon.displayName = "CopyIcon";
// src/icons/components/CropIcon.tsx
const CropIcon = forwardRef((props, ref) => {
	return /* @__PURE__ */ jsx(Icon, {
		...props,
		ref,
		children: /* @__PURE__ */ jsxs("svg", {
			xmlns: "http://www.w3.org/2000/svg",
			width: "24",
			height: "24",
			viewBox: "0 0 24 24",
			fill: "none",
			stroke: "currentColor",
			strokeWidth: "2",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			children: [/* @__PURE__ */ jsx("path", { d: "M6 2v14a2 2 0 0 0 2 2h14" }), /* @__PURE__ */ jsx("path", { d: "M18 22V8a2 2 0 0 0-2-2H2" })]
		})
	});
});
CropIcon.displayName = "CropIcon";
// src/icons/components/CrossIcon.tsx
const CrossIcon = forwardRef((props, ref) => {
	return /* @__PURE__ */ jsx(Icon, {
		...props,
		ref,
		children: /* @__PURE__ */ jsx("svg", {
			xmlns: "http://www.w3.org/2000/svg",
			width: "24",
			height: "24",
			viewBox: "0 0 24 24",
			fill: "none",
			stroke: "currentColor",
			strokeWidth: "2",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			children: /* @__PURE__ */ jsx("path", { d: "M4 9a2 2 0 0 0-2 2v2a2 2 0 0 0 2 2h4a1 1 0 0 1 1 1v4a2 2 0 0 0 2 2h2a2 2 0 0 0 2-2v-4a1 1 0 0 1 1-1h4a2 2 0 0 0 2-2v-2a2 2 0 0 0-2-2h-4a1 1 0 0 1-1-1V4a2 2 0 0 0-2-2h-2a2 2 0 0 0-2 2v4a1 1 0 0 1-1 1z" })
		})
	});
});
CrossIcon.displayName = "CrossIcon";
// src/icons/components/EarthIcon.tsx
const EarthIcon = forwardRef((props, ref) => {
	return /* @__PURE__ */ jsx(Icon, {
		...props,
		ref,
		children: /* @__PURE__ */ jsxs("svg", {
			xmlns: "http://www.w3.org/2000/svg",
			width: "24",
			height: "24",
			viewBox: "0 0 24 24",
			fill: "none",
			stroke: "currentColor",
			strokeWidth: "2",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			children: [
				/* @__PURE__ */ jsx("path", { d: "M21.54 15H17a2 2 0 0 0-2 2v4.54" }),
				/* @__PURE__ */ jsx("path", { d: "M7 3.34V5a3 3 0 0 0 3 3a2 2 0 0 1 2 2c0 1.1.9 2 2 2a2 2 0 0 0 2-2c0-1.1.9-2 2-2h3.17" }),
				/* @__PURE__ */ jsx("path", { d: "M11 21.95V18a2 2 0 0 0-2-2a2 2 0 0 1-2-2v-1a2 2 0 0 0-2-2H2.05" }),
				/* @__PURE__ */ jsx("circle", {
					cx: "12",
					cy: "12",
					r: "10"
				})
			]
		})
	});
});
EarthIcon.displayName = "EarthIcon";
// src/icons/components/ExternalLinkIcon.tsx
const ExternalLinkIcon = forwardRef((props, ref) => {
	return /* @__PURE__ */ jsx(Icon, {
		...props,
		ref,
		children: /* @__PURE__ */ jsxs("svg", {
			xmlns: "http://www.w3.org/2000/svg",
			width: "24",
			height: "24",
			viewBox: "0 0 24 24",
			fill: "none",
			stroke: "currentColor",
			strokeWidth: "2",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			children: [
				/* @__PURE__ */ jsx("path", { d: "M15 3h6v6" }),
				/* @__PURE__ */ jsx("path", { d: "M10 14 21 3" }),
				/* @__PURE__ */ jsx("path", { d: "M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6" })
			]
		})
	});
});
ExternalLinkIcon.displayName = "ExternalLinkIcon";
// src/icons/components/EyeIcon.tsx
const EyeIcon = forwardRef((props, ref) => {
	return /* @__PURE__ */ jsx(Icon, {
		...props,
		ref,
		children: /* @__PURE__ */ jsxs("svg", {
			xmlns: "http://www.w3.org/2000/svg",
			width: "24",
			height: "24",
			viewBox: "0 0 24 24",
			fill: "none",
			stroke: "currentColor",
			strokeWidth: "2",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			children: [/* @__PURE__ */ jsx("path", { d: "M2.062 12.348a1 1 0 0 1 0-.696 10.75 10.75 0 0 1 19.876 0 1 1 0 0 1 0 .696 10.75 10.75 0 0 1-19.876 0" }), /* @__PURE__ */ jsx("circle", {
				cx: "12",
				cy: "12",
				r: "3"
			})]
		})
	});
});
EyeIcon.displayName = "EyeIcon";
// src/icons/components/EyeOffIcon.tsx
const EyeOffIcon = forwardRef((props, ref) => {
	return /* @__PURE__ */ jsx(Icon, {
		...props,
		ref,
		children: /* @__PURE__ */ jsxs("svg", {
			xmlns: "http://www.w3.org/2000/svg",
			width: "24",
			height: "24",
			viewBox: "0 0 24 24",
			fill: "none",
			stroke: "currentColor",
			strokeWidth: "2",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			children: [
				/* @__PURE__ */ jsx("path", { d: "M10.733 5.076a10.744 10.744 0 0 1 11.205 6.575 1 1 0 0 1 0 .696 10.747 10.747 0 0 1-1.444 2.49" }),
				/* @__PURE__ */ jsx("path", { d: "M14.084 14.158a3 3 0 0 1-4.242-4.242" }),
				/* @__PURE__ */ jsx("path", { d: "M17.479 17.499a10.75 10.75 0 0 1-15.417-5.151 1 1 0 0 1 0-.696 10.75 10.75 0 0 1 4.446-5.143" }),
				/* @__PURE__ */ jsx("path", { d: "m2 2 20 20" })
			]
		})
	});
});
EyeOffIcon.displayName = "EyeOffIcon";
// src/icons/components/facebook/FacebookLogoIcon.tsx
const FacebookLogoIcon = forwardRef((props, ref) => {
	return /* @__PURE__ */ jsx(Icon, {
		...props,
		ref,
		children: /* @__PURE__ */ jsx("svg", {
			xmlns: "http://www.w3.org/2000/svg",
			fill: "none",
			width: "24",
			height: "24",
			viewBox: "0 0 24 24",
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: "2",
			children: /* @__PURE__ */ jsx("path", { d: "M18 2h-3a5 5 0 0 0-5 5v3H7v4h3v8h4v-8h3l1-4h-4V7a1 1 0 0 1 1-1h3z" })
		})
	});
});
FacebookLogoIcon.displayName = "FacebookLogoIcon";
// src/icons/components/facebook/MessageCircleIcon.tsx
const MessageCircleIcon = forwardRef((props, ref) => {
	return /* @__PURE__ */ jsx(Icon, {
		...props,
		ref,
		children: /* @__PURE__ */ jsx("svg", {
			xmlns: "http://www.w3.org/2000/svg",
			width: "24",
			height: "24",
			viewBox: "0 0 24 24",
			fill: "none",
			stroke: "currentColor",
			strokeWidth: "2",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			children: /* @__PURE__ */ jsx("path", { d: "M2.992 16.342a2 2 0 0 1 .094 1.167l-1.065 3.29a1 1 0 0 0 1.236 1.168l3.413-.998a2 2 0 0 1 1.099.092 10 10 0 1 0-4.777-4.719" })
		})
	});
});
MessageCircleIcon.displayName = "MessageCircleIcon";
// src/icons/components/facebook/ShareArrowIcon.tsx
const ShareArrowIcon = forwardRef((props, ref) => {
	return /* @__PURE__ */ jsx(Icon, {
		...props,
		ref,
		children: /* @__PURE__ */ jsx("svg", {
			stroke: "currentColor",
			fill: "currentColor",
			strokeWidth: "2",
			viewBox: "0 0 256 256",
			height: "24",
			width: "24",
			xmlns: "http://www.w3.org/2000/svg",
			children: /* @__PURE__ */ jsx("path", { d: "M237.66,106.35l-80-80A8,8,0,0,0,144,32V72.35c-25.94,2.22-54.59,14.92-78.16,34.91-28.38,24.08-46.05,55.11-49.76,87.37a12,12,0,0,0,20.68,9.58h0c11-11.71,50.14-48.74,107.24-52V192a8,8,0,0,0,13.66,5.65l80-80A8,8,0,0,0,237.66,106.35ZM160,172.69V144a8,8,0,0,0-8-8c-28.08,0-55.43,7.33-81.29,21.8a196.17,196.17,0,0,0-36.57,26.52c5.8-23.84,20.42-46.51,42.05-64.86C99.41,99.77,127.75,88,152,88a8,8,0,0,0,8-8V51.32L220.69,112Z" })
		})
	});
});
ShareArrowIcon.displayName = "ShareArrowIcon";
// src/icons/components/facebook/ThumbsUpIcon.tsx
const ThumbsUpIcon = forwardRef((props, ref) => {
	return /* @__PURE__ */ jsx(Icon, {
		...props,
		ref,
		children: /* @__PURE__ */ jsxs("svg", {
			xmlns: "http://www.w3.org/2000/svg",
			width: "24",
			height: "24",
			viewBox: "0 0 24 24",
			fill: "none",
			stroke: "currentColor",
			strokeWidth: "2",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			children: [/* @__PURE__ */ jsx("path", { d: "M15 5.88 14 10h5.83a2 2 0 0 1 1.92 2.56l-2.33 8A2 2 0 0 1 17.5 22H4a2 2 0 0 1-2-2v-8a2 2 0 0 1 2-2h2.76a2 2 0 0 0 1.79-1.11L12 2a3.13 3.13 0 0 1 3 3.88Z" }), /* @__PURE__ */ jsx("path", { d: "M7 10v12" })]
		})
	});
});
ThumbsUpIcon.displayName = "ThumbsUpIcon";
// src/icons/components/FileDownIcon.tsx
const FileDownIcon = forwardRef((props, ref) => {
	return /* @__PURE__ */ jsx(Icon, {
		...props,
		ref,
		children: /* @__PURE__ */ jsxs("svg", {
			xmlns: "http://www.w3.org/2000/svg",
			width: "24",
			height: "24",
			viewBox: "0 0 24 24",
			fill: "none",
			stroke: "currentColor",
			strokeWidth: "2",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			children: [
				/* @__PURE__ */ jsx("path", { d: "M6 22a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h8a2.4 2.4 0 0 1 1.704.706l3.588 3.588A2.4 2.4 0 0 1 20 8v12a2 2 0 0 1-2 2z" }),
				/* @__PURE__ */ jsx("path", { d: "M14 2v5a1 1 0 0 0 1 1h5" }),
				/* @__PURE__ */ jsx("path", { d: "M12 18v-6" }),
				/* @__PURE__ */ jsx("path", { d: "m9 15 3 3 3-3" })
			]
		})
	});
});
FileDownIcon.displayName = "FileDownIcon";
// src/icons/components/FileIcon.tsx
const FileIcon = forwardRef((props, ref) => {
	return /* @__PURE__ */ jsx(Icon, {
		...props,
		ref,
		children: /* @__PURE__ */ jsxs("svg", {
			xmlns: "http://www.w3.org/2000/svg",
			width: "24",
			height: "24",
			viewBox: "0 0 24 24",
			fill: "none",
			stroke: "currentColor",
			strokeWidth: "2",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			children: [/* @__PURE__ */ jsx("path", { d: "M6 22a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h8a2.4 2.4 0 0 1 1.704.706l3.588 3.588A2.4 2.4 0 0 1 20 8v12a2 2 0 0 1-2 2z" }), /* @__PURE__ */ jsx("path", { d: "M14 2v5a1 1 0 0 0 1 1h5" })]
		})
	});
});
FileIcon.displayName = "FileIcon";
// src/icons/components/FileQuestionMarkIcon.tsx
const FileQuestionMarkIcon = forwardRef((props, ref) => {
	return /* @__PURE__ */ jsx(Icon, {
		...props,
		ref,
		children: /* @__PURE__ */ jsxs("svg", {
			xmlns: "http://www.w3.org/2000/svg",
			width: "24",
			height: "24",
			viewBox: "0 0 24 24",
			fill: "none",
			stroke: "currentColor",
			strokeWidth: "2",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			children: [
				/* @__PURE__ */ jsx("path", { d: "M12 17h.01" }),
				/* @__PURE__ */ jsx("path", { d: "M15 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7z" }),
				/* @__PURE__ */ jsx("path", { d: "M9.1 9a3 3 0 0 1 5.82 1c0 2-3 3-3 3" })
			]
		})
	});
});
FileQuestionMarkIcon.displayName = "FileQuestionMarkIcon";
// src/icons/components/FileUpIcon.tsx
const FileUpIcon = forwardRef((props, ref) => {
	return /* @__PURE__ */ jsx(Icon, {
		...props,
		ref,
		children: /* @__PURE__ */ jsxs("svg", {
			xmlns: "http://www.w3.org/2000/svg",
			width: "24",
			height: "24",
			viewBox: "0 0 24 24",
			fill: "none",
			stroke: "currentColor",
			strokeWidth: "2",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			children: [
				/* @__PURE__ */ jsx("path", { d: "M6 22a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h8a2.4 2.4 0 0 1 1.704.706l3.588 3.588A2.4 2.4 0 0 1 20 8v12a2 2 0 0 1-2 2z" }),
				/* @__PURE__ */ jsx("path", { d: "M14 2v5a1 1 0 0 0 1 1h5" }),
				/* @__PURE__ */ jsx("path", { d: "M12 12v6" }),
				/* @__PURE__ */ jsx("path", { d: "m15 15-3-3-3 3" })
			]
		})
	});
});
FileUpIcon.displayName = "FileUpIcon";
// src/icons/components/FlaskConicalIcon.tsx
const FlaskConicalIcon = forwardRef((props, ref) => {
	return /* @__PURE__ */ jsx(Icon, {
		...props,
		ref,
		children: /* @__PURE__ */ jsxs("svg", {
			xmlns: "http://www.w3.org/2000/svg",
			width: "24",
			height: "24",
			viewBox: "0 0 24 24",
			fill: "none",
			stroke: "currentColor",
			strokeWidth: "2",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			children: [
				/* @__PURE__ */ jsx("path", { d: "M14 2v6a2 2 0 0 0 .245.96l5.51 10.08A2 2 0 0 1 18 22H6a2 2 0 0 1-1.755-2.96l5.51-10.08A2 2 0 0 0 10 8V2" }),
				/* @__PURE__ */ jsx("path", { d: "M6.453 15h11.094" }),
				/* @__PURE__ */ jsx("path", { d: "M8.5 2h7" })
			]
		})
	});
});
FlaskConicalIcon.displayName = "FlaskConicalIcon";
// src/icons/components/GhostIcon.tsx
const GhostIcon = forwardRef((props, ref) => {
	return /* @__PURE__ */ jsx(Icon, {
		...props,
		ref,
		children: /* @__PURE__ */ jsxs("svg", {
			xmlns: "http://www.w3.org/2000/svg",
			width: "24",
			height: "24",
			viewBox: "0 0 24 24",
			fill: "none",
			stroke: "currentColor",
			strokeWidth: "2",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			children: [
				/* @__PURE__ */ jsx("path", { d: "M15 10v1" }),
				/* @__PURE__ */ jsx("path", { d: "M7.528 20.472a1.6 1.6 0 012.277 0l1.057 1.056a1.6 1.6 0 002.276 0l1.057-1.056a1.6 1.6 0 012.277 0l1.114 1.114a1.4 1.4 0 002.414-1V10a8 8 0 00-16 0v10.586a1.4 1.4 0 002.414 1z" }),
				/* @__PURE__ */ jsx("path", { d: "M9 10v1" })
			]
		})
	});
});
GhostIcon.displayName = "GhostIcon";
// src/icons/components/GraduationCapIcon.tsx
const GraduationCapIcon = forwardRef((props, ref) => {
	return /* @__PURE__ */ jsx(Icon, {
		...props,
		ref,
		children: /* @__PURE__ */ jsxs("svg", {
			xmlns: "http://www.w3.org/2000/svg",
			width: "24",
			height: "24",
			viewBox: "0 0 24 24",
			fill: "none",
			stroke: "currentColor",
			strokeWidth: "2",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			children: [
				/* @__PURE__ */ jsx("path", { d: "M21.42 10.922a1 1 0 0 0-.019-1.838L12.83 5.18a2 2 0 0 0-1.66 0L2.6 9.08a1 1 0 0 0 0 1.832l8.57 3.908a2 2 0 0 0 1.66 0z" }),
				/* @__PURE__ */ jsx("path", { d: "M22 10v6" }),
				/* @__PURE__ */ jsx("path", { d: "M6 12.5V16a6 3 0 0 0 12 0v-3.5" })
			]
		})
	});
});
GraduationCapIcon.displayName = "GraduationCapIcon";
// src/icons/components/GroupIcon.tsx
const GroupIcon = forwardRef((props, ref) => {
	return /* @__PURE__ */ jsx(Icon, {
		...props,
		ref,
		children: /* @__PURE__ */ jsxs("svg", {
			xmlns: "http://www.w3.org/2000/svg",
			width: "24",
			height: "24",
			viewBox: "0 0 24 24",
			fill: "none",
			stroke: "currentColor",
			strokeWidth: "2",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			children: [
				/* @__PURE__ */ jsx("path", { d: "M3 7V5c0-1.1.9-2 2-2h2" }),
				/* @__PURE__ */ jsx("path", { d: "M17 3h2c1.1 0 2 .9 2 2v2" }),
				/* @__PURE__ */ jsx("path", { d: "M21 17v2c0 1.1-.9 2-2 2h-2" }),
				/* @__PURE__ */ jsx("path", { d: "M7 21H5c-1.1 0-2-.9-2-2v-2" }),
				/* @__PURE__ */ jsx("rect", {
					width: "7",
					height: "5",
					x: "7",
					y: "7",
					rx: "1"
				}),
				/* @__PURE__ */ jsx("rect", {
					width: "7",
					height: "5",
					x: "10",
					y: "12",
					rx: "1"
				})
			]
		})
	});
});
GroupIcon.displayName = "GroupIcon";
// src/icons/components/HeartIcon.tsx
const HeartIcon = forwardRef((props, ref) => {
	return /* @__PURE__ */ jsx(Icon, {
		...props,
		ref,
		children: /* @__PURE__ */ jsx("svg", {
			xmlns: "http://www.w3.org/2000/svg",
			width: "24",
			height: "24",
			viewBox: "0 0 24 24",
			fill: "none",
			stroke: "currentColor",
			strokeWidth: "2",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			children: /* @__PURE__ */ jsx("path", { d: "M2 9.5a5.5 5.5 0 0 1 9.591-3.676.56.56 0 0 0 .818 0A5.49 5.49 0 0 1 22 9.5c0 2.29-1.5 4-3 5.5l-5.492 5.313a2 2 0 0 1-3 .019L5 15c-1.5-1.5-3-3.2-3-5.5" })
		})
	});
});
HeartIcon.displayName = "HeartIcon";
// src/icons/components/HorizontalEllipsisIcon.tsx
const HorizontalEllipsisIcon = forwardRef((props, ref) => {
	return /* @__PURE__ */ jsx(Icon, {
		...props,
		ref,
		children: /* @__PURE__ */ jsxs("svg", {
			xmlns: "http://www.w3.org/2000/svg",
			width: "24",
			height: "24",
			viewBox: "0 0 24 24",
			fill: "none",
			stroke: "currentColor",
			strokeWidth: "2",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			children: [
				/* @__PURE__ */ jsx("circle", {
					cx: "12",
					cy: "12",
					r: "1"
				}),
				/* @__PURE__ */ jsx("circle", {
					cx: "19",
					cy: "12",
					r: "1"
				}),
				/* @__PURE__ */ jsx("circle", {
					cx: "5",
					cy: "12",
					r: "1"
				})
			]
		})
	});
});
HorizontalEllipsisIcon.displayName = "HorizontalEllipsisIcon";
// src/icons/components/HorizontalGripIcon.tsx
const HorizontalGripIcon = forwardRef((props, ref) => {
	return /* @__PURE__ */ jsx(Icon, {
		...props,
		ref,
		color: "#555555",
		children: /* @__PURE__ */ jsxs("svg", {
			xmlns: "http://www.w3.org/2000/svg",
			width: "24",
			height: "24",
			viewBox: "0 0 24 24",
			fill: "none",
			stroke: "currentColor",
			strokeWidth: "2",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			children: [
				/* @__PURE__ */ jsx("circle", {
					cx: "12",
					cy: "9",
					r: "1"
				}),
				/* @__PURE__ */ jsx("circle", {
					cx: "19",
					cy: "9",
					r: "1"
				}),
				/* @__PURE__ */ jsx("circle", {
					cx: "5",
					cy: "9",
					r: "1"
				}),
				/* @__PURE__ */ jsx("circle", {
					cx: "12",
					cy: "15",
					r: "1"
				}),
				/* @__PURE__ */ jsx("circle", {
					cx: "19",
					cy: "15",
					r: "1"
				}),
				/* @__PURE__ */ jsx("circle", {
					cx: "5",
					cy: "15",
					r: "1"
				})
			]
		})
	});
});
HorizontalGripIcon.displayName = "HorizontalGripIcon";
// src/icons/components/HouseHeartIcon.tsx
const HouseHeartIcon = forwardRef((props, ref) => {
	return /* @__PURE__ */ jsx(Icon, {
		...props,
		ref,
		children: /* @__PURE__ */ jsxs("svg", {
			xmlns: "http://www.w3.org/2000/svg",
			width: "24",
			height: "24",
			viewBox: "0 0 24 24",
			fill: "none",
			stroke: "currentColor",
			strokeWidth: "2",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			children: [/* @__PURE__ */ jsx("path", { d: "M8.62 13.8A2.25 2.25 0 1 1 12 10.836a2.25 2.25 0 1 1 3.38 2.966l-2.626 2.856a.998.998 0 0 1-1.507 0z" }), /* @__PURE__ */ jsx("path", { d: "M3 10a2 2 0 0 1 .709-1.528l7-6a2 2 0 0 1 2.582 0l7 6A2 2 0 0 1 21 10v9a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z" })]
		})
	});
});
HouseHeartIcon.displayName = "HouseHeartIcon";
// src/icons/components/ImagePlusIcon.tsx
const ImagePlusIcon = forwardRef((props, ref) => {
	return /* @__PURE__ */ jsx(Icon, {
		...props,
		ref,
		children: /* @__PURE__ */ jsxs("svg", {
			xmlns: "http://www.w3.org/2000/svg",
			width: "24",
			height: "24",
			viewBox: "0 0 24 24",
			fill: "none",
			stroke: "currentColor",
			strokeWidth: "2",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			children: [
				/* @__PURE__ */ jsx("path", { d: "M16 5h6" }),
				/* @__PURE__ */ jsx("path", { d: "M19 2v6" }),
				/* @__PURE__ */ jsx("path", { d: "M21 11.5V19a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h7.5" }),
				/* @__PURE__ */ jsx("path", { d: "m21 15-3.086-3.086a2 2 0 0 0-2.828 0L6 21" }),
				/* @__PURE__ */ jsx("circle", {
					cx: "9",
					cy: "9",
					r: "2"
				})
			]
		})
	});
});
ImagePlusIcon.displayName = "ImagePlusIcon";
// src/icons/components/ImagesIcon.tsx
const ImagesIcon = forwardRef((props, ref) => {
	return /* @__PURE__ */ jsx(Icon, {
		...props,
		ref,
		children: /* @__PURE__ */ jsxs("svg", {
			xmlns: "http://www.w3.org/2000/svg",
			width: "24",
			height: "24",
			viewBox: "0 0 24 24",
			fill: "none",
			stroke: "currentColor",
			strokeWidth: "2",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			children: [
				/* @__PURE__ */ jsx("path", { d: "m22 11-1.296-1.296a2.4 2.4 0 0 0-3.408 0L11 16" }),
				/* @__PURE__ */ jsx("path", { d: "M4 8a2 2 0 0 0-2 2v10a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2" }),
				/* @__PURE__ */ jsx("circle", {
					cx: "13",
					cy: "7",
					r: "1",
					fill: "currentColor"
				}),
				/* @__PURE__ */ jsx("rect", {
					x: "8",
					y: "2",
					width: "14",
					height: "14",
					rx: "2"
				})
			]
		})
	});
});
ImagesIcon.displayName = "ImagesIcon";
// src/icons/components/InfoIcon.tsx
const InfoIcon = forwardRef((props, ref) => {
	return /* @__PURE__ */ jsx(Icon, {
		...props,
		ref,
		children: /* @__PURE__ */ jsxs("svg", {
			xmlns: "http://www.w3.org/2000/svg",
			width: "24",
			height: "24",
			viewBox: "0 0 24 24",
			fill: "none",
			stroke: "currentColor",
			strokeWidth: "2",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			children: [
				/* @__PURE__ */ jsx("circle", {
					cx: "12",
					cy: "12",
					r: "10"
				}),
				/* @__PURE__ */ jsx("path", { d: "M12 16v-4" }),
				/* @__PURE__ */ jsx("path", { d: "M12 8h.01" })
			]
		})
	});
});
InfoIcon.displayName = "InfoIcon";
// src/icons/components/KeyIcon.tsx
const KeyIcon = forwardRef((props, ref) => {
	return /* @__PURE__ */ jsx(Icon, {
		...props,
		ref,
		children: /* @__PURE__ */ jsxs("svg", {
			xmlns: "http://www.w3.org/2000/svg",
			width: "24",
			height: "24",
			viewBox: "0 0 24 24",
			fill: "none",
			stroke: "currentColor",
			strokeWidth: "2",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			children: [
				/* @__PURE__ */ jsx("path", { d: "m15.5 7.5 2.3 2.3a1 1 0 0 0 1.4 0l2.1-2.1a1 1 0 0 0 0-1.4L19 4" }),
				/* @__PURE__ */ jsx("path", { d: "m21 2-9.6 9.6" }),
				/* @__PURE__ */ jsx("circle", {
					cx: "7.5",
					cy: "15.5",
					r: "5.5"
				})
			]
		})
	});
});
KeyIcon.displayName = "KeyIcon";
// src/icons/components/KeyRoundIcon.tsx
const KeyRoundIcon = forwardRef((props, ref) => {
	return /* @__PURE__ */ jsx(Icon, {
		...props,
		ref,
		children: /* @__PURE__ */ jsxs("svg", {
			xmlns: "http://www.w3.org/2000/svg",
			width: "24",
			height: "24",
			viewBox: "0 0 24 24",
			fill: "none",
			stroke: "currentColor",
			strokeWidth: "2",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			children: [/* @__PURE__ */ jsx("path", { d: "M2.586 17.414A2 2 0 0 0 2 18.828V21a1 1 0 0 0 1 1h3a1 1 0 0 0 1-1v-1a1 1 0 0 1 1-1h1a1 1 0 0 0 1-1v-1a1 1 0 0 1 1-1h.172a2 2 0 0 0 1.414-.586l.814-.814a6.5 6.5 0 1 0-4-4z" }), /* @__PURE__ */ jsx("circle", {
				cx: "16.5",
				cy: "7.5",
				r: ".5",
				fill: "currentColor"
			})]
		})
	});
});
KeyRoundIcon.displayName = "KeyRoundIcon";
// src/icons/components/LayoutGridIcon.tsx
const LayoutGridIcon = forwardRef((props, ref) => {
	return /* @__PURE__ */ jsx(Icon, {
		...props,
		ref,
		children: /* @__PURE__ */ jsxs("svg", {
			xmlns: "http://www.w3.org/2000/svg",
			width: "24",
			height: "24",
			viewBox: "0 0 24 24",
			fill: "none",
			stroke: "currentColor",
			strokeWidth: "2",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			children: [
				/* @__PURE__ */ jsx("rect", {
					width: "7",
					height: "7",
					x: "3",
					y: "3",
					rx: "1"
				}),
				/* @__PURE__ */ jsx("rect", {
					width: "7",
					height: "7",
					x: "14",
					y: "3",
					rx: "1"
				}),
				/* @__PURE__ */ jsx("rect", {
					width: "7",
					height: "7",
					x: "14",
					y: "14",
					rx: "1"
				}),
				/* @__PURE__ */ jsx("rect", {
					width: "7",
					height: "7",
					x: "3",
					y: "14",
					rx: "1"
				})
			]
		})
	});
});
LayoutGridIcon.displayName = "LayoutGridIcon";
// src/icons/components/LinkIcon.tsx
const LinkIcon = forwardRef((props, ref) => {
	return /* @__PURE__ */ jsx(Icon, {
		...props,
		ref,
		children: /* @__PURE__ */ jsxs("svg", {
			xmlns: "http://www.w3.org/2000/svg",
			width: "24",
			height: "24",
			viewBox: "0 0 24 24",
			fill: "none",
			stroke: "currentColor",
			strokeWidth: "2",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			children: [/* @__PURE__ */ jsx("path", { d: "M10 13a5 5 0 0 0 7.54.54l3-3a5 5 0 0 0-7.07-7.07l-1.72 1.71" }), /* @__PURE__ */ jsx("path", { d: "M14 11a5 5 0 0 0-7.54-.54l-3 3a5 5 0 0 0 7.07 7.07l1.71-1.71" })]
		})
	});
});
LinkIcon.displayName = "LinkIcon";
// src/icons/components/ListIcon.tsx
const ListIcon = forwardRef((props, ref) => {
	return /* @__PURE__ */ jsx(Icon, {
		...props,
		ref,
		children: /* @__PURE__ */ jsxs("svg", {
			xmlns: "http://www.w3.org/2000/svg",
			width: "24",
			height: "24",
			viewBox: "0 0 24 24",
			fill: "none",
			stroke: "currentColor",
			strokeWidth: "2",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			children: [
				/* @__PURE__ */ jsx("path", { d: "M3 5h.01" }),
				/* @__PURE__ */ jsx("path", { d: "M3 12h.01" }),
				/* @__PURE__ */ jsx("path", { d: "M3 19h.01" }),
				/* @__PURE__ */ jsx("path", { d: "M8 5h13" }),
				/* @__PURE__ */ jsx("path", { d: "M8 12h13" }),
				/* @__PURE__ */ jsx("path", { d: "M8 19h13" })
			]
		})
	});
});
ListIcon.displayName = "ListIcon";
// src/icons/components/LockIcon.tsx
const LockIcon = forwardRef((props, ref) => {
	return /* @__PURE__ */ jsx(Icon, {
		...props,
		ref,
		children: /* @__PURE__ */ jsxs("svg", {
			xmlns: "http://www.w3.org/2000/svg",
			width: "24",
			height: "24",
			viewBox: "0 0 24 24",
			fill: "none",
			stroke: "currentColor",
			strokeWidth: "2",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			children: [/* @__PURE__ */ jsx("rect", {
				width: "18",
				height: "11",
				x: "3",
				y: "11",
				rx: "2",
				ry: "2"
			}), /* @__PURE__ */ jsx("path", { d: "M7 11V7a5 5 0 0 1 10 0v4" })]
		})
	});
});
LockIcon.displayName = "LockIcon";
// src/icons/components/LockOpenIcon.tsx
const LockOpenIcon = forwardRef((props, ref) => {
	return /* @__PURE__ */ jsx(Icon, {
		...props,
		ref,
		children: /* @__PURE__ */ jsxs("svg", {
			xmlns: "http://www.w3.org/2000/svg",
			width: "24",
			height: "24",
			viewBox: "0 0 24 24",
			fill: "none",
			stroke: "currentColor",
			strokeWidth: "2",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			children: [/* @__PURE__ */ jsx("rect", {
				width: "18",
				height: "11",
				x: "3",
				y: "11",
				rx: "2",
				ry: "2"
			}), /* @__PURE__ */ jsx("path", { d: "M7 11V7a5 5 0 0 1 9.9-1" })]
		})
	});
});
LockOpenIcon.displayName = "LockOpenIcon";
// src/icons/components/MailIcon.tsx
const MailIcon = forwardRef((props, ref) => {
	return /* @__PURE__ */ jsx(Icon, {
		...props,
		ref,
		children: /* @__PURE__ */ jsxs("svg", {
			xmlns: "http://www.w3.org/2000/svg",
			width: "24",
			height: "24",
			viewBox: "0 0 24 24",
			fill: "none",
			stroke: "currentColor",
			strokeWidth: "2",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			children: [/* @__PURE__ */ jsx("path", { d: "m22 7-8.991 5.727a2 2 0 0 1-2.009 0L2 7" }), /* @__PURE__ */ jsx("rect", {
				x: "2",
				y: "4",
				width: "20",
				height: "16",
				rx: "2"
			})]
		})
	});
});
MailIcon.displayName = "MailIcon";
// src/icons/components/Maximize2Icon.tsx
const Maximize2Icon = forwardRef((props, ref) => {
	return /* @__PURE__ */ jsx(Icon, {
		...props,
		ref,
		children: /* @__PURE__ */ jsxs("svg", {
			xmlns: "http://www.w3.org/2000/svg",
			width: "24",
			height: "24",
			viewBox: "0 0 24 24",
			fill: "none",
			stroke: "currentColor",
			strokeWidth: "2",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			children: [
				/* @__PURE__ */ jsx("path", { d: "M15 3h6v6" }),
				/* @__PURE__ */ jsx("path", { d: "m21 3-7 7" }),
				/* @__PURE__ */ jsx("path", { d: "m3 21 7-7" }),
				/* @__PURE__ */ jsx("path", { d: "M9 21H3v-6" })
			]
		})
	});
});
Maximize2Icon.displayName = "Maximize2Icon";
// src/icons/components/MegaphoneIcon.tsx
const MegaphoneIcon = forwardRef((props, ref) => {
	return /* @__PURE__ */ jsx(Icon, {
		...props,
		ref,
		children: /* @__PURE__ */ jsxs("svg", {
			xmlns: "http://www.w3.org/2000/svg",
			width: "24",
			height: "24",
			viewBox: "0 0 24 24",
			fill: "none",
			stroke: "currentColor",
			strokeWidth: "2",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			children: [
				/* @__PURE__ */ jsx("path", { d: "M11 6a13 13 0 0 0 8.4-2.8A1 1 0 0 1 21 4v12a1 1 0 0 1-1.6.8A13 13 0 0 0 11 14H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2z" }),
				/* @__PURE__ */ jsx("path", { d: "M6 14a12 12 0 0 0 2.4 7.2 2 2 0 0 0 3.2-2.4A8 8 0 0 1 10 14" }),
				/* @__PURE__ */ jsx("path", { d: "M8 6v8" })
			]
		})
	});
});
MegaphoneIcon.displayName = "MegaphoneIcon";
// src/icons/components/MenuIcon.tsx
const MenuIcon = forwardRef((props, ref) => {
	return /* @__PURE__ */ jsx(Icon, {
		...props,
		ref,
		children: /* @__PURE__ */ jsxs("svg", {
			xmlns: "http://www.w3.org/2000/svg",
			width: "24",
			height: "24",
			viewBox: "0 0 24 24",
			fill: "none",
			stroke: "currentColor",
			strokeWidth: "2",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			children: [
				/* @__PURE__ */ jsx("path", { d: "M4 5h16" }),
				/* @__PURE__ */ jsx("path", { d: "M4 12h16" }),
				/* @__PURE__ */ jsx("path", { d: "M4 19h16" })
			]
		})
	});
});
MenuIcon.displayName = "MenuIcon";
// src/icons/components/MessageCircleMoreIcon.tsx
const MessageCircleMoreIcon = forwardRef((props, ref) => {
	return /* @__PURE__ */ jsx(Icon, {
		...props,
		ref,
		children: /* @__PURE__ */ jsxs("svg", {
			xmlns: "http://www.w3.org/2000/svg",
			width: "24",
			height: "24",
			viewBox: "0 0 24 24",
			fill: "none",
			stroke: "currentColor",
			strokeWidth: "2",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			children: [
				/* @__PURE__ */ jsx("path", { d: "M2.992 16.342a2 2 0 0 1 .094 1.167l-1.065 3.29a1 1 0 0 0 1.236 1.168l3.413-.998a2 2 0 0 1 1.099.092 10 10 0 1 0-4.777-4.719" }),
				/* @__PURE__ */ jsx("path", { d: "M8 12h.01" }),
				/* @__PURE__ */ jsx("path", { d: "M12 12h.01" }),
				/* @__PURE__ */ jsx("path", { d: "M16 12h.01" })
			]
		})
	});
});
MessageCircleMoreIcon.displayName = "MessageCircleMoreIcon";
// src/icons/components/MessagesSquareIcon.tsx
const MessagesSquareIcon = forwardRef((props, ref) => {
	return /* @__PURE__ */ jsx(Icon, {
		...props,
		ref,
		children: /* @__PURE__ */ jsxs("svg", {
			xmlns: "http://www.w3.org/2000/svg",
			width: "24",
			height: "24",
			viewBox: "0 0 24 24",
			fill: "none",
			stroke: "currentColor",
			strokeWidth: "2",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			children: [/* @__PURE__ */ jsx("path", { d: "M16 10a2 2 0 0 1-2 2H6.828a2 2 0 0 0-1.414.586l-2.202 2.202A.71.71 0 0 1 2 14.286V4a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2z" }), /* @__PURE__ */ jsx("path", { d: "M20 9a2 2 0 0 1 2 2v10.286a.71.71 0 0 1-1.212.502l-2.202-2.202A2 2 0 0 0 17.172 19H10a2 2 0 0 1-2-2v-1" })]
		})
	});
});
MessagesSquareIcon.displayName = "MessagesSquareIcon";
// src/icons/components/MonitorIcon.tsx
const MonitorIcon = forwardRef((props, ref) => {
	return /* @__PURE__ */ jsx(Icon, {
		...props,
		ref,
		children: /* @__PURE__ */ jsxs("svg", {
			xmlns: "http://www.w3.org/2000/svg",
			width: "24",
			height: "24",
			viewBox: "0 0 24 24",
			fill: "none",
			stroke: "currentColor",
			strokeWidth: "2",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			children: [
				/* @__PURE__ */ jsx("rect", {
					width: "20",
					height: "14",
					x: "2",
					y: "3",
					rx: "2"
				}),
				/* @__PURE__ */ jsx("line", {
					x1: "8",
					x2: "16",
					y1: "21",
					y2: "21"
				}),
				/* @__PURE__ */ jsx("line", {
					x1: "12",
					x2: "12",
					y1: "17",
					y2: "21"
				})
			]
		})
	});
});
MonitorIcon.displayName = "MonitorIcon";
// src/icons/components/NewspaperIcon.tsx
const NewspaperIcon = forwardRef((props, ref) => {
	return /* @__PURE__ */ jsx(Icon, {
		...props,
		ref,
		children: /* @__PURE__ */ jsxs("svg", {
			xmlns: "http://www.w3.org/2000/svg",
			width: "24",
			height: "24",
			viewBox: "0 0 24 24",
			fill: "none",
			stroke: "currentColor",
			strokeWidth: "2",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			children: [
				/* @__PURE__ */ jsx("path", { d: "M15 18h-5" }),
				/* @__PURE__ */ jsx("path", { d: "M18 14h-8" }),
				/* @__PURE__ */ jsx("path", { d: "M4 22h16a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2H8a2 2 0 0 0-2 2v16a2 2 0 0 1-4 0v-9a2 2 0 0 1 2-2h2" }),
				/* @__PURE__ */ jsx("rect", {
					width: "8",
					height: "4",
					x: "10",
					y: "6",
					rx: "1"
				})
			]
		})
	});
});
NewspaperIcon.displayName = "NewspaperIcon";
// src/icons/components/NotebookPenIcon.tsx
const NotebookPenIcon = forwardRef((props, ref) => {
	return /* @__PURE__ */ jsx(Icon, {
		...props,
		ref,
		children: /* @__PURE__ */ jsxs("svg", {
			xmlns: "http://www.w3.org/2000/svg",
			width: "24",
			height: "24",
			viewBox: "0 0 24 24",
			fill: "none",
			stroke: "currentColor",
			strokeWidth: "2",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			children: [
				/* @__PURE__ */ jsx("path", { d: "M13.4 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-7.4" }),
				/* @__PURE__ */ jsx("path", { d: "M2 6h4" }),
				/* @__PURE__ */ jsx("path", { d: "M2 10h4" }),
				/* @__PURE__ */ jsx("path", { d: "M2 14h4" }),
				/* @__PURE__ */ jsx("path", { d: "M2 18h4" }),
				/* @__PURE__ */ jsx("path", { d: "M21.378 5.626a1 1 0 1 0-3.004-3.004l-5.01 5.012a2 2 0 0 0-.506.854l-.837 2.87a.5.5 0 0 0 .62.62l2.87-.837a2 2 0 0 0 .854-.506z" })
			]
		})
	});
});
NotebookPenIcon.displayName = "NotebookPenIcon";
// src/icons/components/NotebookTabsIcon.tsx
const NotebookTabsIcon = forwardRef((props, ref) => {
	return /* @__PURE__ */ jsx(Icon, {
		...props,
		ref,
		children: /* @__PURE__ */ jsxs("svg", {
			xmlns: "http://www.w3.org/2000/svg",
			width: "24",
			height: "24",
			viewBox: "0 0 24 24",
			fill: "none",
			stroke: "currentColor",
			strokeWidth: "2",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			children: [
				/* @__PURE__ */ jsx("path", { d: "M2 6h4" }),
				/* @__PURE__ */ jsx("path", { d: "M2 10h4" }),
				/* @__PURE__ */ jsx("path", { d: "M2 14h4" }),
				/* @__PURE__ */ jsx("path", { d: "M2 18h4" }),
				/* @__PURE__ */ jsx("rect", {
					width: "16",
					height: "20",
					x: "4",
					y: "2",
					rx: "2"
				}),
				/* @__PURE__ */ jsx("path", { d: "M15 2v20" }),
				/* @__PURE__ */ jsx("path", { d: "M15 7h5" }),
				/* @__PURE__ */ jsx("path", { d: "M15 12h5" }),
				/* @__PURE__ */ jsx("path", { d: "M15 17h5" })
			]
		})
	});
});
NotebookTabsIcon.displayName = "NotebookTabsIcon";
// src/icons/components/PackageIcon.tsx
const PackageIcon = forwardRef((props, ref) => {
	return /* @__PURE__ */ jsx(Icon, {
		...props,
		ref,
		children: /* @__PURE__ */ jsxs("svg", {
			xmlns: "http://www.w3.org/2000/svg",
			width: "24",
			height: "24",
			viewBox: "0 0 24 24",
			fill: "none",
			stroke: "currentColor",
			strokeWidth: "2",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			children: [
				/* @__PURE__ */ jsx("path", { d: "M11 21.73a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73z" }),
				/* @__PURE__ */ jsx("path", { d: "M12 22V12" }),
				/* @__PURE__ */ jsx("polyline", { points: "3.29 7 12 12 20.71 7" }),
				/* @__PURE__ */ jsx("path", { d: "m7.5 4.27 9 5.15" })
			]
		})
	});
});
PackageIcon.displayName = "PackageIcon";
// src/icons/components/PaperClipIcon.tsx
const PaperClipIcon = forwardRef((props, ref) => {
	return /* @__PURE__ */ jsx(Icon, {
		...props,
		ref,
		children: /* @__PURE__ */ jsx("svg", {
			xmlns: "http://www.w3.org/2000/svg",
			width: "24",
			height: "24",
			viewBox: "0 0 24 24",
			fill: "none",
			stroke: "currentColor",
			strokeWidth: "2",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			children: /* @__PURE__ */ jsx("path", { d: "m16 6-8.414 8.586a2 2 0 0 0 2.829 2.829l8.414-8.586a4 4 0 1 0-5.657-5.657l-8.379 8.551a6 6 0 1 0 8.485 8.485l8.379-8.551" })
		})
	});
});
PaperClipIcon.displayName = "PaperClipIcon";
// src/icons/components/PencilIcon.tsx
const PencilIcon = forwardRef((props, ref) => {
	return /* @__PURE__ */ jsx(Icon, {
		...props,
		ref,
		children: /* @__PURE__ */ jsxs("svg", {
			xmlns: "http://www.w3.org/2000/svg",
			width: "24",
			height: "24",
			viewBox: "0 0 24 24",
			fill: "none",
			stroke: "currentColor",
			strokeWidth: "2",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			children: [/* @__PURE__ */ jsx("path", { d: "M21.174 6.812a1 1 0 0 0-3.986-3.987L3.842 16.174a2 2 0 0 0-.5.83l-1.321 4.352a.5.5 0 0 0 .623.622l4.353-1.32a2 2 0 0 0 .83-.497z" }), /* @__PURE__ */ jsx("path", { d: "m15 5 4 4" })]
		})
	});
});
PencilIcon.displayName = "PencilIcon";
// src/icons/components/PhoneIcon.tsx
const PhoneIcon = forwardRef((props, ref) => {
	return /* @__PURE__ */ jsx(Icon, {
		...props,
		ref,
		children: /* @__PURE__ */ jsx("svg", {
			xmlns: "http://www.w3.org/2000/svg",
			width: "24",
			height: "24",
			viewBox: "0 0 24 24",
			fill: "none",
			stroke: "currentColor",
			strokeWidth: "2",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			children: /* @__PURE__ */ jsx("path", { d: "M13.832 16.568a1 1 0 0 0 1.213-.303l.355-.465A2 2 0 0 1 17 15h3a2 2 0 0 1 2 2v3a2 2 0 0 1-2 2A18 18 0 0 1 2 4a2 2 0 0 1 2-2h3a2 2 0 0 1 2 2v3a2 2 0 0 1-.8 1.6l-.468.351a1 1 0 0 0-.292 1.233 14 14 0 0 0 6.392 6.384" })
		})
	});
});
PhoneIcon.displayName = "PhoneIcon";
// src/icons/components/PinIcon.tsx
const PinIcon = forwardRef((props, ref) => {
	return /* @__PURE__ */ jsx(Icon, {
		...props,
		ref,
		children: /* @__PURE__ */ jsxs("svg", {
			xmlns: "http://www.w3.org/2000/svg",
			width: "24",
			height: "24",
			viewBox: "0 0 24 24",
			fill: "none",
			stroke: "currentColor",
			strokeWidth: "2",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			children: [/* @__PURE__ */ jsx("path", { d: "M12 17v5" }), /* @__PURE__ */ jsx("path", { d: "M9 10.76a2 2 0 0 1-1.11 1.79l-1.78.9A2 2 0 0 0 5 15.24V16a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-.76a2 2 0 0 0-1.11-1.79l-1.78-.9A2 2 0 0 1 15 10.76V7a1 1 0 0 1 1-1 2 2 0 0 0 0-4H8a2 2 0 0 0 0 4 1 1 0 0 1 1 1z" })]
		})
	});
});
PinIcon.displayName = "PinIcon";
// src/icons/components/PinOffIcon.tsx
const PinOffIcon = forwardRef((props, ref) => {
	return /* @__PURE__ */ jsx(Icon, {
		...props,
		ref,
		children: /* @__PURE__ */ jsxs("svg", {
			xmlns: "http://www.w3.org/2000/svg",
			width: "24",
			height: "24",
			viewBox: "0 0 24 24",
			fill: "none",
			stroke: "currentColor",
			strokeWidth: "2",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			children: [
				/* @__PURE__ */ jsx("path", { d: "M12 17v5" }),
				/* @__PURE__ */ jsx("path", { d: "M15 9.34V7a1 1 0 0 1 1-1 2 2 0 0 0 0-4H7.89" }),
				/* @__PURE__ */ jsx("path", { d: "m2 2 20 20" }),
				/* @__PURE__ */ jsx("path", { d: "M9 9v1.76a2 2 0 0 1-1.11 1.79l-1.78.9A2 2 0 0 0 5 15.24V16a1 1 0 0 0 1 1h11" })
			]
		})
	});
});
PinOffIcon.displayName = "PinOffIcon";
// src/icons/components/PlusIcon.tsx
const PlusIcon = forwardRef((props, ref) => {
	return /* @__PURE__ */ jsx(Icon, {
		...props,
		ref,
		children: /* @__PURE__ */ jsxs("svg", {
			xmlns: "http://www.w3.org/2000/svg",
			width: "24",
			height: "24",
			viewBox: "0 0 24 24",
			fill: "none",
			stroke: "currentColor",
			strokeWidth: "2",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			children: [/* @__PURE__ */ jsx("path", { d: "M5 12h14" }), /* @__PURE__ */ jsx("path", { d: "M12 5v14" })]
		})
	});
});
PlusIcon.displayName = "PlusIcon";
// src/icons/components/PresentationIcon.tsx
const PresentationIcon = forwardRef((props, ref) => {
	return /* @__PURE__ */ jsx(Icon, {
		...props,
		ref,
		children: /* @__PURE__ */ jsxs("svg", {
			xmlns: "http://www.w3.org/2000/svg",
			width: "24",
			height: "24",
			viewBox: "0 0 24 24",
			fill: "none",
			stroke: "currentColor",
			strokeWidth: "2",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			children: [
				/* @__PURE__ */ jsx("path", { d: "M2 3h20" }),
				/* @__PURE__ */ jsx("path", { d: "M21 3v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V3" }),
				/* @__PURE__ */ jsx("path", { d: "m7 21 5-5 5 5" })
			]
		})
	});
});
PresentationIcon.displayName = "PresentationIcon";
// src/icons/components/PrintIcon.tsx
const PrintIcon = forwardRef((props, ref) => {
	return /* @__PURE__ */ jsx(Icon, {
		...props,
		ref,
		children: /* @__PURE__ */ jsxs("svg", {
			xmlns: "http://www.w3.org/2000/svg",
			width: "24",
			height: "24",
			viewBox: "0 0 24 24",
			fill: "none",
			stroke: "currentColor",
			strokeWidth: "2",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			children: [
				/* @__PURE__ */ jsx("path", { d: "M6 18H4a2 2 0 0 1-2-2v-5a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v5a2 2 0 0 1-2 2h-2" }),
				/* @__PURE__ */ jsx("path", { d: "M6 9V3a1 1 0 0 1 1-1h10a1 1 0 0 1 1 1v6" }),
				/* @__PURE__ */ jsx("rect", {
					x: "6",
					y: "14",
					width: "12",
					height: "8",
					rx: "1"
				})
			]
		})
	});
});
PrintIcon.displayName = "PrintIcon";
// src/icons/components/QRCodeIcon.tsx
const QRCodeIcon = forwardRef((props, ref) => {
	return /* @__PURE__ */ jsx(Icon, {
		...props,
		ref,
		children: /* @__PURE__ */ jsxs("svg", {
			xmlns: "http://www.w3.org/2000/svg",
			width: "24",
			height: "24",
			viewBox: "0 0 24 24",
			fill: "none",
			stroke: "currentColor",
			strokeWidth: "2",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			children: [
				/* @__PURE__ */ jsx("rect", {
					width: "5",
					height: "5",
					x: "3",
					y: "3",
					rx: "1"
				}),
				/* @__PURE__ */ jsx("rect", {
					width: "5",
					height: "5",
					x: "16",
					y: "3",
					rx: "1"
				}),
				/* @__PURE__ */ jsx("rect", {
					width: "5",
					height: "5",
					x: "3",
					y: "16",
					rx: "1"
				}),
				/* @__PURE__ */ jsx("path", { d: "M21 16h-3a2 2 0 0 0-2 2v3" }),
				/* @__PURE__ */ jsx("path", { d: "M21 21v.01" }),
				/* @__PURE__ */ jsx("path", { d: "M12 7v3a2 2 0 0 1-2 2H7" }),
				/* @__PURE__ */ jsx("path", { d: "M3 12h.01" }),
				/* @__PURE__ */ jsx("path", { d: "M12 3h.01" }),
				/* @__PURE__ */ jsx("path", { d: "M12 16v.01" }),
				/* @__PURE__ */ jsx("path", { d: "M16 12h1" }),
				/* @__PURE__ */ jsx("path", { d: "M21 12v.01" }),
				/* @__PURE__ */ jsx("path", { d: "M12 21v-1" })
			]
		})
	});
});
QRCodeIcon.displayName = "QRCodeIcon";
// src/icons/components/RefreshCWIcon.tsx
const RefreshCWIcon = forwardRef((props, ref) => {
	return /* @__PURE__ */ jsx(Icon, {
		...props,
		ref,
		children: /* @__PURE__ */ jsxs("svg", {
			xmlns: "http://www.w3.org/2000/svg",
			width: "24",
			height: "24",
			viewBox: "0 0 24 24",
			fill: "none",
			stroke: "currentColor",
			strokeWidth: "2",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			children: [
				/* @__PURE__ */ jsx("path", { d: "M3 12a9 9 0 0 1 9-9 9.75 9.75 0 0 1 6.74 2.74L21 8" }),
				/* @__PURE__ */ jsx("path", { d: "M21 3v5h-5" }),
				/* @__PURE__ */ jsx("path", { d: "M21 12a9 9 0 0 1-9 9 9.75 9.75 0 0 1-6.74-2.74L3 16" }),
				/* @__PURE__ */ jsx("path", { d: "M8 16H3v5" })
			]
		})
	});
});
RefreshCWIcon.displayName = "RefreshCWIcon";
// src/icons/components/rich-text-editor/BoldIcon.tsx
const BoldIcon = forwardRef((props, ref) => {
	return /* @__PURE__ */ jsx(Icon, {
		...props,
		ref,
		children: /* @__PURE__ */ jsx("svg", {
			xmlns: "http://www.w3.org/2000/svg",
			width: "24",
			height: "24",
			viewBox: "0 0 24 24",
			fill: "none",
			stroke: "currentColor",
			strokeWidth: "2",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			children: /* @__PURE__ */ jsx("path", { d: "M6 12h9a4 4 0 0 1 0 8H7a1 1 0 0 1-1-1V5a1 1 0 0 1 1-1h7a4 4 0 0 1 0 8" })
		})
	});
});
BoldIcon.displayName = "BoldIcon";
// src/icons/components/rich-text-editor/H1Icon.tsx
const H1Icon = forwardRef((props, ref) => {
	return /* @__PURE__ */ jsx(Icon, {
		...props,
		ref,
		children: /* @__PURE__ */ jsxs("svg", {
			xmlns: "http://www.w3.org/2000/svg",
			width: "24",
			height: "24",
			viewBox: "0 0 24 24",
			fill: "none",
			stroke: "currentColor",
			strokeWidth: "2",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			children: [
				/* @__PURE__ */ jsx("path", { d: "M4 12h8" }),
				/* @__PURE__ */ jsx("path", { d: "M4 18V6" }),
				/* @__PURE__ */ jsx("path", { d: "M12 18V6" }),
				/* @__PURE__ */ jsx("path", { d: "m17 12 3-2v8" })
			]
		})
	});
});
H1Icon.displayName = "H1Icon";
// src/icons/components/rich-text-editor/H2Icon.tsx
const H2Icon = forwardRef((props, ref) => {
	return /* @__PURE__ */ jsx(Icon, {
		...props,
		ref,
		children: /* @__PURE__ */ jsxs("svg", {
			xmlns: "http://www.w3.org/2000/svg",
			width: "24",
			height: "24",
			viewBox: "0 0 24 24",
			fill: "none",
			stroke: "currentColor",
			strokeWidth: "2",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			children: [
				/* @__PURE__ */ jsx("path", { d: "M4 12h8" }),
				/* @__PURE__ */ jsx("path", { d: "M4 18V6" }),
				/* @__PURE__ */ jsx("path", { d: "M12 18V6" }),
				/* @__PURE__ */ jsx("path", { d: "M21 18h-4c0-4 4-3 4-6 0-1.5-2-2.5-4-1" })
			]
		})
	});
});
H2Icon.displayName = "H2Icon";
// src/icons/components/rich-text-editor/ImageIcon.tsx
const ImageIcon = forwardRef((props, ref) => {
	return /* @__PURE__ */ jsx(Icon, {
		...props,
		ref,
		children: /* @__PURE__ */ jsxs("svg", {
			xmlns: "http://www.w3.org/2000/svg",
			width: "24",
			height: "24",
			viewBox: "0 0 24 24",
			fill: "none",
			stroke: "currentColor",
			strokeWidth: "2",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			children: [
				/* @__PURE__ */ jsx("path", { d: "M15 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7Z" }),
				/* @__PURE__ */ jsx("path", { d: "M14 2v4a2 2 0 0 0 2 2h4" }),
				/* @__PURE__ */ jsx("circle", {
					cx: "10",
					cy: "12",
					r: "2"
				}),
				/* @__PURE__ */ jsx("path", { d: "m20 17-1.296-1.296a2.41 2.41 0 0 0-3.408 0L9 22" })
			]
		})
	});
});
ImageIcon.displayName = "ImageIcon";
// src/icons/components/rich-text-editor/ItalicIcon.tsx
const ItalicIcon = forwardRef((props, ref) => {
	return /* @__PURE__ */ jsx(Icon, {
		...props,
		ref,
		children: /* @__PURE__ */ jsxs("svg", {
			xmlns: "http://www.w3.org/2000/svg",
			width: "24",
			height: "24",
			viewBox: "0 0 24 24",
			fill: "none",
			stroke: "currentColor",
			strokeWidth: "2",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			children: [
				/* @__PURE__ */ jsx("line", {
					x1: "19",
					x2: "10",
					y1: "4",
					y2: "4"
				}),
				/* @__PURE__ */ jsx("line", {
					x1: "14",
					x2: "5",
					y1: "20",
					y2: "20"
				}),
				/* @__PURE__ */ jsx("line", {
					x1: "15",
					x2: "9",
					y1: "4",
					y2: "20"
				})
			]
		})
	});
});
ItalicIcon.displayName = "ItalicIcon";
// src/icons/components/rich-text-editor/OrderListIcon.tsx
const OrderListIcon = forwardRef((props, ref) => {
	return /* @__PURE__ */ jsx(Icon, {
		...props,
		ref,
		children: /* @__PURE__ */ jsxs("svg", {
			xmlns: "http://www.w3.org/2000/svg",
			width: "24",
			height: "24",
			viewBox: "0 0 24 24",
			fill: "none",
			stroke: "currentColor",
			strokeWidth: "2",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			children: [
				/* @__PURE__ */ jsx("path", { d: "M11 5h10" }),
				/* @__PURE__ */ jsx("path", { d: "M11 12h10" }),
				/* @__PURE__ */ jsx("path", { d: "M11 19h10" }),
				/* @__PURE__ */ jsx("path", { d: "M4 4h1v5" }),
				/* @__PURE__ */ jsx("path", { d: "M4 9h2" }),
				/* @__PURE__ */ jsx("path", { d: "M6.5 20H3.4c0-1 2.6-1.925 2.6-3.5a1.5 1.5 0 0 0-2.6-1.02" })
			]
		})
	});
});
OrderListIcon.displayName = "OrderListIcon";
// src/icons/components/rich-text-editor/QuoteIcon.tsx
const QuoteIcon = forwardRef((props, ref) => {
	return /* @__PURE__ */ jsx(Icon, {
		...props,
		ref,
		children: /* @__PURE__ */ jsxs("svg", {
			xmlns: "http://www.w3.org/2000/svg",
			width: "24",
			height: "24",
			viewBox: "0 0 24 24",
			fill: "none",
			stroke: "currentColor",
			strokeWidth: "2",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			children: [/* @__PURE__ */ jsx("path", { d: "M16 3a2 2 0 0 0-2 2v6a2 2 0 0 0 2 2 1 1 0 0 1 1 1v1a2 2 0 0 1-2 2 1 1 0 0 0-1 1v2a1 1 0 0 0 1 1 6 6 0 0 0 6-6V5a2 2 0 0 0-2-2z" }), /* @__PURE__ */ jsx("path", { d: "M5 3a2 2 0 0 0-2 2v6a2 2 0 0 0 2 2 1 1 0 0 1 1 1v1a2 2 0 0 1-2 2 1 1 0 0 0-1 1v2a1 1 0 0 0 1 1 6 6 0 0 0 6-6V5a2 2 0 0 0-2-2z" })]
		})
	});
});
QuoteIcon.displayName = "QuoteIcon";
// src/icons/components/rich-text-editor/RedoIcon.tsx
const RedoIcon = forwardRef((props, ref) => {
	return /* @__PURE__ */ jsx(Icon, {
		...props,
		ref,
		children: /* @__PURE__ */ jsxs("svg", {
			xmlns: "http://www.w3.org/2000/svg",
			width: "24",
			height: "24",
			viewBox: "0 0 24 24",
			fill: "none",
			stroke: "currentColor",
			strokeWidth: "2",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			children: [/* @__PURE__ */ jsx("path", { d: "m15 14 5-5-5-5" }), /* @__PURE__ */ jsx("path", { d: "M20 9H9.5A5.5 5.5 0 0 0 4 14.5A5.5 5.5 0 0 0 9.5 20H13" })]
		})
	});
});
RedoIcon.displayName = "RedoIcon";
// src/icons/components/rich-text-editor/SquareImageIcon.tsx
const SquareImageIcon = forwardRef((props, ref) => {
	return /* @__PURE__ */ jsx(Icon, {
		...props,
		ref,
		children: /* @__PURE__ */ jsxs("svg", {
			xmlns: "http://www.w3.org/2000/svg",
			width: "24",
			height: "24",
			viewBox: "0 0 24 24",
			fill: "none",
			stroke: "currentColor",
			strokeWidth: "2",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			children: [
				/* @__PURE__ */ jsx("rect", {
					width: "18",
					height: "18",
					x: "3",
					y: "3",
					rx: "2",
					ry: "2"
				}),
				/* @__PURE__ */ jsx("circle", {
					cx: "9",
					cy: "9",
					r: "2"
				}),
				/* @__PURE__ */ jsx("path", { d: "m21 15-3.086-3.086a2 2 0 0 0-2.828 0L6 21" })
			]
		})
	});
});
SquareImageIcon.displayName = "SquareImageIcon";
// src/icons/components/rich-text-editor/UnderlineIcon.tsx
const UnderlineIcon = forwardRef((props, ref) => {
	return /* @__PURE__ */ jsx(Icon, {
		...props,
		ref,
		children: /* @__PURE__ */ jsxs("svg", {
			xmlns: "http://www.w3.org/2000/svg",
			width: "24",
			height: "24",
			viewBox: "0 0 24 24",
			fill: "none",
			stroke: "currentColor",
			strokeWidth: "2",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			children: [/* @__PURE__ */ jsx("path", { d: "M6 4v6a6 6 0 0 0 12 0V4" }), /* @__PURE__ */ jsx("line", {
				x1: "4",
				x2: "20",
				y1: "20",
				y2: "20"
			})]
		})
	});
});
UnderlineIcon.displayName = "UnderlineIcon";
// src/icons/components/rich-text-editor/UndoIcon.tsx
const UndoIcon = forwardRef((props, ref) => {
	return /* @__PURE__ */ jsx(Icon, {
		...props,
		ref,
		children: /* @__PURE__ */ jsxs("svg", {
			xmlns: "http://www.w3.org/2000/svg",
			width: "24",
			height: "24",
			viewBox: "0 0 24 24",
			fill: "none",
			stroke: "currentColor",
			strokeWidth: "2",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			children: [/* @__PURE__ */ jsx("path", { d: "M9 14 4 9l5-5" }), /* @__PURE__ */ jsx("path", { d: "M4 9h10.5a5.5 5.5 0 0 1 5.5 5.5a5.5 5.5 0 0 1-5.5 5.5H11" })]
		})
	});
});
UndoIcon.displayName = "UndoIcon";
// src/icons/components/rich-text-editor/UnorderListIcon.tsx
const UnorderListIcon = forwardRef((props, ref) => {
	return /* @__PURE__ */ jsx(Icon, {
		...props,
		ref,
		children: /* @__PURE__ */ jsxs("svg", {
			xmlns: "http://www.w3.org/2000/svg",
			width: "24",
			height: "24",
			viewBox: "0 0 24 24",
			fill: "none",
			stroke: "currentColor",
			strokeWidth: "2",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			children: [
				/* @__PURE__ */ jsx("path", { d: "M3 5h.01" }),
				/* @__PURE__ */ jsx("path", { d: "M3 12h.01" }),
				/* @__PURE__ */ jsx("path", { d: "M3 19h.01" }),
				/* @__PURE__ */ jsx("path", { d: "M8 5h13" }),
				/* @__PURE__ */ jsx("path", { d: "M8 12h13" }),
				/* @__PURE__ */ jsx("path", { d: "M8 19h13" })
			]
		})
	});
});
UnorderListIcon.displayName = "UnorderListIcon";
// src/icons/components/RocketIcon.tsx
const RocketIcon = forwardRef((props, ref) => {
	return /* @__PURE__ */ jsx(Icon, {
		...props,
		ref,
		children: /* @__PURE__ */ jsxs("svg", {
			xmlns: "http://www.w3.org/2000/svg",
			width: "24",
			height: "24",
			viewBox: "0 0 24 24",
			fill: "none",
			stroke: "currentColor",
			strokeWidth: "2",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			children: [
				/* @__PURE__ */ jsx("path", { d: "M4.5 16.5c-1.5 1.26-2 5-2 5s3.74-.5 5-2c.71-.84.7-2.13-.09-2.91a2.18 2.18 0 0 0-2.91-.09z" }),
				/* @__PURE__ */ jsx("path", { d: "m12 15-3-3a22 22 0 0 1 2-3.95A12.88 12.88 0 0 1 22 2c0 2.72-.78 7.5-6 11a22.35 22.35 0 0 1-4 2z" }),
				/* @__PURE__ */ jsx("path", { d: "M9 12H4s.55-3.03 2-4c1.62-1.08 5 0 5 0" }),
				/* @__PURE__ */ jsx("path", { d: "M12 15v5s3.03-.55 4-2c1.08-1.62 0-5 0-5" })
			]
		})
	});
});
RocketIcon.displayName = "RocketIcon";
// src/icons/components/RotateCCWIcon.tsx
const RotateCCWIcon = forwardRef((props, ref) => {
	return /* @__PURE__ */ jsx(Icon, {
		...props,
		ref,
		children: /* @__PURE__ */ jsxs("svg", {
			xmlns: "http://www.w3.org/2000/svg",
			width: "24",
			height: "24",
			viewBox: "0 0 24 24",
			fill: "none",
			stroke: "currentColor",
			strokeWidth: "2",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			children: [/* @__PURE__ */ jsx("path", { d: "M3 12a9 9 0 1 0 9-9 9.75 9.75 0 0 0-6.74 2.74L3 8" }), /* @__PURE__ */ jsx("path", { d: "M3 3v5h5" })]
		})
	});
});
RotateCCWIcon.displayName = "RotateCCWIcon";
// src/icons/components/SearchIcon.tsx
const SearchIcon = forwardRef((props, ref) => {
	return /* @__PURE__ */ jsx(Icon, {
		...props,
		ref,
		children: /* @__PURE__ */ jsxs("svg", {
			xmlns: "http://www.w3.org/2000/svg",
			width: "24",
			height: "24",
			viewBox: "0 0 24 24",
			fill: "none",
			stroke: "currentColor",
			strokeWidth: "2",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			children: [/* @__PURE__ */ jsx("path", { d: "m21 21-4.34-4.34" }), /* @__PURE__ */ jsx("circle", {
				cx: "11",
				cy: "11",
				r: "8"
			})]
		})
	});
});
SearchIcon.displayName = "SearchIcon";
// src/icons/components/SendIcon.tsx
const SendIcon = forwardRef((props, ref) => {
	return /* @__PURE__ */ jsx(Icon, {
		...props,
		ref,
		children: /* @__PURE__ */ jsxs("svg", {
			xmlns: "http://www.w3.org/2000/svg",
			width: "24",
			height: "24",
			viewBox: "0 0 24 24",
			fill: "none",
			stroke: "currentColor",
			strokeWidth: "2",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			children: [/* @__PURE__ */ jsx("path", { d: "M14.536 21.686a.5.5 0 0 0 .937-.024l6.5-19a.496.496 0 0 0-.635-.635l-19 6.5a.5.5 0 0 0-.024.937l7.93 3.18a2 2 0 0 1 1.112 1.11z" }), /* @__PURE__ */ jsx("path", { d: "m21.854 2.147-10.94 10.939" })]
		})
	});
});
SendIcon.displayName = "SendIcon";
// src/icons/components/SettingsIcon.tsx
const SettingsIcon = forwardRef((props, ref) => {
	return /* @__PURE__ */ jsx(Icon, {
		...props,
		ref,
		children: /* @__PURE__ */ jsxs("svg", {
			xmlns: "http://www.w3.org/2000/svg",
			width: "24",
			height: "24",
			viewBox: "0 0 24 24",
			fill: "none",
			stroke: "currentColor",
			strokeWidth: "2",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			children: [/* @__PURE__ */ jsx("path", { d: "M12.22 2h-.44a2 2 0 0 0-2 2v.18a2 2 0 0 1-1 1.73l-.43.25a2 2 0 0 1-2 0l-.15-.08a2 2 0 0 0-2.73.73l-.22.38a2 2 0 0 0 .73 2.73l.15.1a2 2 0 0 1 1 1.72v.51a2 2 0 0 1-1 1.74l-.15.09a2 2 0 0 0-.73 2.73l.22.38a2 2 0 0 0 2.73.73l.15-.08a2 2 0 0 1 2 0l.43.25a2 2 0 0 1 1 1.73V20a2 2 0 0 0 2 2h.44a2 2 0 0 0 2-2v-.18a2 2 0 0 1 1-1.73l.43-.25a2 2 0 0 1 2 0l.15.08a2 2 0 0 0 2.73-.73l.22-.39a2 2 0 0 0-.73-2.73l-.15-.08a2 2 0 0 1-1-1.74v-.5a2 2 0 0 1 1-1.74l.15-.09a2 2 0 0 0 .73-2.73l-.22-.38a2 2 0 0 0-2.73-.73l-.15.08a2 2 0 0 1-2 0l-.43-.25a2 2 0 0 1-1-1.73V4a2 2 0 0 0-2-2z" }), /* @__PURE__ */ jsx("circle", {
				cx: "12",
				cy: "12",
				r: "3"
			})]
		})
	});
});
SettingsIcon.displayName = "SettingsIcon";
// src/icons/components/Share2Icon.tsx
const Share2Icon = forwardRef((props, ref) => {
	return /* @__PURE__ */ jsx(Icon, {
		...props,
		ref,
		children: /* @__PURE__ */ jsxs("svg", {
			xmlns: "http://www.w3.org/2000/svg",
			width: "24",
			height: "24",
			viewBox: "0 0 24 24",
			fill: "none",
			stroke: "currentColor",
			strokeWidth: "2",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			children: [
				/* @__PURE__ */ jsx("circle", {
					cx: "18",
					cy: "5",
					r: "3"
				}),
				/* @__PURE__ */ jsx("circle", {
					cx: "6",
					cy: "12",
					r: "3"
				}),
				/* @__PURE__ */ jsx("circle", {
					cx: "18",
					cy: "19",
					r: "3"
				}),
				/* @__PURE__ */ jsx("line", {
					x1: "8.59",
					x2: "15.42",
					y1: "13.51",
					y2: "17.49"
				}),
				/* @__PURE__ */ jsx("line", {
					x1: "15.41",
					x2: "8.59",
					y1: "6.51",
					y2: "10.49"
				})
			]
		})
	});
});
Share2Icon.displayName = "Share2Icon";
// src/icons/components/ShoppingCartIcon.tsx
const ShoppingCartIcon = forwardRef((props, ref) => {
	return /* @__PURE__ */ jsx(Icon, {
		...props,
		ref,
		children: /* @__PURE__ */ jsxs("svg", {
			xmlns: "http://www.w3.org/2000/svg",
			width: "24",
			height: "24",
			viewBox: "0 0 24 24",
			fill: "none",
			stroke: "currentColor",
			strokeWidth: "2",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			children: [
				/* @__PURE__ */ jsx("circle", {
					cx: "8",
					cy: "21",
					r: "1"
				}),
				/* @__PURE__ */ jsx("circle", {
					cx: "19",
					cy: "21",
					r: "1"
				}),
				/* @__PURE__ */ jsx("path", { d: "M2.05 2.05h2l2.66 12.42a2 2 0 0 0 2 1.58h9.78a2 2 0 0 0 1.95-1.57l1.65-7.43H5.12" })
			]
		})
	});
});
ShoppingCartIcon.displayName = "ShoppingCartIcon";
// src/icons/components/SparklesIcon.tsx
const SparklesIcon = forwardRef((props, ref) => {
	return /* @__PURE__ */ jsx(Icon, {
		...props,
		ref,
		children: /* @__PURE__ */ jsxs("svg", {
			xmlns: "http://www.w3.org/2000/svg",
			width: "24",
			height: "24",
			viewBox: "0 0 24 24",
			fill: "none",
			stroke: "currentColor",
			strokeWidth: "2",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			children: [
				/* @__PURE__ */ jsx("path", { d: "M11.017 2.814a1 1 0 0 1 1.966 0l1.051 5.558a2 2 0 0 0 1.594 1.594l5.558 1.051a1 1 0 0 1 0 1.966l-5.558 1.051a2 2 0 0 0-1.594 1.594l-1.051 5.558a1 1 0 0 1-1.966 0l-1.051-5.558a2 2 0 0 0-1.594-1.594l-5.558-1.051a1 1 0 0 1 0-1.966l5.558-1.051a2 2 0 0 0 1.594-1.594z" }),
				/* @__PURE__ */ jsx("path", { d: "M20 2v4" }),
				/* @__PURE__ */ jsx("path", { d: "M22 4h-4" }),
				/* @__PURE__ */ jsx("circle", {
					cx: "4",
					cy: "20",
					r: "2"
				})
			]
		})
	});
});
SparklesIcon.displayName = "SparklesIcon";
// src/icons/components/SquarePenIcon.tsx
const SquarePenIcon = forwardRef((props, ref) => {
	return /* @__PURE__ */ jsx(Icon, {
		...props,
		ref,
		children: /* @__PURE__ */ jsxs("svg", {
			xmlns: "http://www.w3.org/2000/svg",
			width: "24",
			height: "24",
			viewBox: "0 0 24 24",
			fill: "none",
			stroke: "currentColor",
			strokeWidth: "2",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			children: [/* @__PURE__ */ jsx("path", { d: "M12 3H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7" }), /* @__PURE__ */ jsx("path", { d: "M18.375 2.625a1 1 0 0 1 3 3l-9.013 9.014a2 2 0 0 1-.853.505l-2.873.84a.5.5 0 0 1-.62-.62l.84-2.873a2 2 0 0 1 .506-.852z" })]
		})
	});
});
SquarePenIcon.displayName = "SquarePenIcon";
// src/icons/components/SquarePlayIcon.tsx
const SquarePlayIcon = forwardRef((props, ref) => {
	return /* @__PURE__ */ jsx(Icon, {
		...props,
		ref,
		children: /* @__PURE__ */ jsxs("svg", {
			xmlns: "http://www.w3.org/2000/svg",
			width: "24",
			height: "24",
			viewBox: "0 0 24 24",
			fill: "none",
			stroke: "currentColor",
			strokeWidth: "2",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			children: [/* @__PURE__ */ jsx("rect", {
				x: "3",
				y: "3",
				width: "18",
				height: "18",
				rx: "2"
			}), /* @__PURE__ */ jsx("path", { d: "M9 9.003a1 1 0 0 1 1.517-.859l4.997 2.997a1 1 0 0 1 0 1.718l-4.997 2.997A1 1 0 0 1 9 14.996z" })]
		})
	});
});
SquarePlayIcon.displayName = "SquarePlayIcon";
// src/icons/components/SquarePlusIcon.tsx
const SquarePlusIcon = forwardRef((props, ref) => {
	return /* @__PURE__ */ jsx(Icon, {
		...props,
		ref,
		children: /* @__PURE__ */ jsxs("svg", {
			xmlns: "http://www.w3.org/2000/svg",
			width: "24",
			height: "24",
			viewBox: "0 0 24 24",
			fill: "none",
			stroke: "currentColor",
			strokeWidth: "2",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			children: [
				/* @__PURE__ */ jsx("rect", {
					width: "18",
					height: "18",
					x: "3",
					y: "3",
					rx: "2"
				}),
				/* @__PURE__ */ jsx("path", { d: "M8 12h8" }),
				/* @__PURE__ */ jsx("path", { d: "M12 8v8" })
			]
		})
	});
});
SquarePlusIcon.displayName = "SquarePlusIcon";
// src/icons/components/SquaresSubtractIcon.tsx
const SquaresSubtractIcon = forwardRef((props, ref) => {
	return /* @__PURE__ */ jsx(Icon, {
		...props,
		ref,
		children: /* @__PURE__ */ jsxs("svg", {
			xmlns: "http://www.w3.org/2000/svg",
			width: "24",
			height: "24",
			viewBox: "0 0 24 24",
			fill: "none",
			stroke: "currentColor",
			strokeWidth: "2",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			children: [
				/* @__PURE__ */ jsx("path", { d: "M10 22a2 2 0 0 1-2-2" }),
				/* @__PURE__ */ jsx("path", { d: "M16 22h-2" }),
				/* @__PURE__ */ jsx("path", { d: "M16 4a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2v10a2 2 0 0 0 2 2h3a1 1 0 0 0 1-1v-5a2 2 0 0 1 2-2h5a1 1 0 0 0 1-1z" }),
				/* @__PURE__ */ jsx("path", { d: "M20 8a2 2 0 0 1 2 2" }),
				/* @__PURE__ */ jsx("path", { d: "M22 14v2" }),
				/* @__PURE__ */ jsx("path", { d: "M22 20a2 2 0 0 1-2 2" })
			]
		})
	});
});
SquaresSubtractIcon.displayName = "SquaresSubtractIcon";
// src/icons/components/StethoscopeIcon.tsx
const StethoscopeIcon = forwardRef((props, ref) => {
	return /* @__PURE__ */ jsx(Icon, {
		...props,
		ref,
		children: /* @__PURE__ */ jsxs("svg", {
			xmlns: "http://www.w3.org/2000/svg",
			width: "24",
			height: "24",
			viewBox: "0 0 24 24",
			fill: "none",
			stroke: "currentColor",
			strokeWidth: "2",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			children: [
				/* @__PURE__ */ jsx("path", { d: "M11 2v2" }),
				/* @__PURE__ */ jsx("path", { d: "M5 2v2" }),
				/* @__PURE__ */ jsx("path", { d: "M5 3H4a2 2 0 0 0-2 2v4a6 6 0 0 0 12 0V5a2 2 0 0 0-2-2h-1" }),
				/* @__PURE__ */ jsx("path", { d: "M8 15a6 6 0 0 0 12 0v-3" }),
				/* @__PURE__ */ jsx("circle", {
					cx: "20",
					cy: "10",
					r: "2"
				})
			]
		})
	});
});
StethoscopeIcon.displayName = "StethoscopeIcon";
// src/icons/components/StoreIcon.tsx
const StoreIcon = forwardRef((props, ref) => {
	return /* @__PURE__ */ jsx(Icon, {
		...props,
		ref,
		children: /* @__PURE__ */ jsxs("svg", {
			xmlns: "http://www.w3.org/2000/svg",
			width: "24",
			height: "24",
			viewBox: "0 0 24 24",
			fill: "none",
			stroke: "currentColor",
			strokeWidth: "2",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			children: [
				/* @__PURE__ */ jsx("path", { d: "m2 7 4.41-4.41A2 2 0 0 1 7.83 2h8.34a2 2 0 0 1 1.42.59L22 7" }),
				/* @__PURE__ */ jsx("path", { d: "M4 12v8a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-8" }),
				/* @__PURE__ */ jsx("path", { d: "M15 22v-4a2 2 0 0 0-2-2h-2a2 2 0 0 0-2 2v4" }),
				/* @__PURE__ */ jsx("path", { d: "M2 7h20" }),
				/* @__PURE__ */ jsx("path", { d: "M22 7v3a2 2 0 0 1-2 2a2.7 2.7 0 0 1-1.59-.63.7.7 0 0 0-.82 0A2.7 2.7 0 0 1 16 12a2.7 2.7 0 0 1-1.59-.63.7.7 0 0 0-.82 0A2.7 2.7 0 0 1 12 12a2.7 2.7 0 0 1-1.59-.63.7.7 0 0 0-.82 0A2.7 2.7 0 0 1 8 12a2.7 2.7 0 0 1-1.59-.63.7.7 0 0 0-.82 0A2.7 2.7 0 0 1 4 12a2 2 0 0 1-2-2V7" })
			]
		})
	});
});
StoreIcon.displayName = "StoreIcon";
// src/icons/components/Trash2Icon.tsx
const Trash2Icon = forwardRef((props, ref) => {
	return /* @__PURE__ */ jsx(Icon, {
		...props,
		ref,
		children: /* @__PURE__ */ jsxs("svg", {
			xmlns: "http://www.w3.org/2000/svg",
			width: "24",
			height: "24",
			viewBox: "0 0 24 24",
			fill: "none",
			stroke: "currentColor",
			strokeWidth: "2",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			children: [
				/* @__PURE__ */ jsx("path", { d: "M3 6h18" }),
				/* @__PURE__ */ jsx("path", { d: "M19 6v14c0 1-1 2-2 2H7c-1 0-2-1-2-2V6" }),
				/* @__PURE__ */ jsx("path", { d: "M8 6V4c0-1 1-2 2-2h4c1 0 2 1 2 2v2" }),
				/* @__PURE__ */ jsx("line", {
					x1: "10",
					x2: "10",
					y1: "11",
					y2: "17"
				}),
				/* @__PURE__ */ jsx("line", {
					x1: "14",
					x2: "14",
					y1: "11",
					y2: "17"
				})
			]
		})
	});
});
Trash2Icon.displayName = "Trash2Icon";
// src/icons/components/TruckIcon.tsx
const TruckIcon = forwardRef((props, ref) => {
	return /* @__PURE__ */ jsx(Icon, {
		...props,
		ref,
		children: /* @__PURE__ */ jsxs("svg", {
			xmlns: "http://www.w3.org/2000/svg",
			width: "24",
			height: "24",
			viewBox: "0 0 24 24",
			fill: "none",
			stroke: "currentColor",
			strokeWidth: "2",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			children: [
				/* @__PURE__ */ jsx("path", { d: "M14 18V6a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2v11a1 1 0 0 0 1 1h2" }),
				/* @__PURE__ */ jsx("path", { d: "M15 18H9" }),
				/* @__PURE__ */ jsx("path", { d: "M19 18h2a1 1 0 0 0 1-1v-3.65a1 1 0 0 0-.22-.624l-3.48-4.35A1 1 0 0 0 17.52 8H14" }),
				/* @__PURE__ */ jsx("circle", {
					cx: "17",
					cy: "18",
					r: "2"
				}),
				/* @__PURE__ */ jsx("circle", {
					cx: "7",
					cy: "18",
					r: "2"
				})
			]
		})
	});
});
TruckIcon.displayName = "TruckIcon";
// src/icons/components/UploadIcon.tsx
const UploadIcon = forwardRef((props, ref) => {
	return /* @__PURE__ */ jsx(Icon, {
		...props,
		ref,
		children: /* @__PURE__ */ jsxs("svg", {
			xmlns: "http://www.w3.org/2000/svg",
			width: "24",
			height: "24",
			viewBox: "0 0 24 24",
			fill: "none",
			stroke: "currentColor",
			strokeWidth: "2",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			children: [
				/* @__PURE__ */ jsx("path", { d: "M12 3v12" }),
				/* @__PURE__ */ jsx("path", { d: "m17 8-5-5-5 5" }),
				/* @__PURE__ */ jsx("path", { d: "M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" })
			]
		})
	});
});
UploadIcon.displayName = "UploadIcon";
// src/icons/components/UserIcon.tsx
const UserIcon = forwardRef((props, ref) => {
	return /* @__PURE__ */ jsx(Icon, {
		...props,
		ref,
		children: /* @__PURE__ */ jsxs("svg", {
			xmlns: "http://www.w3.org/2000/svg",
			width: "24",
			height: "24",
			viewBox: "0 0 24 24",
			fill: "none",
			stroke: "currentColor",
			strokeWidth: "2",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			children: [/* @__PURE__ */ jsx("path", { d: "M19 21v-2a4 4 0 0 0-4-4H9a4 4 0 0 0-4 4v2" }), /* @__PURE__ */ jsx("circle", {
				cx: "12",
				cy: "7",
				r: "4"
			})]
		})
	});
});
UserIcon.displayName = "UserIcon";
// src/icons/components/UserKeyIcon.tsx
const UserKeyIcon = forwardRef((props, ref) => {
	return /* @__PURE__ */ jsx(Icon, {
		...props,
		ref,
		children: /* @__PURE__ */ jsxs("svg", {
			xmlns: "http://www.w3.org/2000/svg",
			width: "24",
			height: "24",
			viewBox: "0 0 24 24",
			fill: "none",
			stroke: "currentColor",
			strokeWidth: "2",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			children: [
				/* @__PURE__ */ jsx("path", { d: "M20 11v6" }),
				/* @__PURE__ */ jsx("path", { d: "M20 13h2" }),
				/* @__PURE__ */ jsx("path", { d: "M3 21v-2a4 4 0 0 1 4-4h6a4 4 0 0 1 2.072.578" }),
				/* @__PURE__ */ jsx("circle", {
					cx: "10",
					cy: "7",
					r: "4"
				}),
				/* @__PURE__ */ jsx("circle", {
					cx: "20",
					cy: "19",
					r: "2"
				})
			]
		})
	});
});
UserKeyIcon.displayName = "UserKeyIcon";
// src/icons/components/UserLockIcon.tsx
const UserLockIcon = forwardRef((props, ref) => {
	return /* @__PURE__ */ jsx(Icon, {
		...props,
		ref,
		children: /* @__PURE__ */ jsxs("svg", {
			xmlns: "http://www.w3.org/2000/svg",
			width: "24",
			height: "24",
			viewBox: "0 0 24 24",
			fill: "none",
			stroke: "currentColor",
			strokeWidth: "2",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			children: [
				/* @__PURE__ */ jsx("circle", {
					cx: "10",
					cy: "7",
					r: "4"
				}),
				/* @__PURE__ */ jsx("path", { d: "M10.3 15H7a4 4 0 0 0-4 4v2" }),
				/* @__PURE__ */ jsx("path", { d: "M15 15.5V14a2 2 0 0 1 4 0v1.5" }),
				/* @__PURE__ */ jsx("rect", {
					width: "8",
					height: "5",
					x: "13",
					y: "16",
					rx: ".899"
				})
			]
		})
	});
});
UserLockIcon.displayName = "UserLockIcon";
// src/icons/components/UserPenIcon.tsx
const UserPenIcon = forwardRef((props, ref) => {
	return /* @__PURE__ */ jsx(Icon, {
		...props,
		ref,
		children: /* @__PURE__ */ jsxs("svg", {
			xmlns: "http://www.w3.org/2000/svg",
			width: "24",
			height: "24",
			viewBox: "0 0 24 24",
			fill: "none",
			stroke: "currentColor",
			strokeWidth: "2",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			children: [
				/* @__PURE__ */ jsx("path", { d: "M11.5 15H7a4 4 0 0 0-4 4v2" }),
				/* @__PURE__ */ jsx("path", { d: "M21.378 16.626a1 1 0 0 0-3.004-3.004l-4.01 4.012a2 2 0 0 0-.506.854l-.837 2.87a.5.5 0 0 0 .62.62l2.87-.837a2 2 0 0 0 .854-.506z" }),
				/* @__PURE__ */ jsx("circle", {
					cx: "10",
					cy: "7",
					r: "4"
				})
			]
		})
	});
});
UserPenIcon.displayName = "UserPenIcon";
// src/icons/components/UserPlusIcon.tsx
const UserPlusIcon = forwardRef((props, ref) => {
	return /* @__PURE__ */ jsx(Icon, {
		...props,
		ref,
		children: /* @__PURE__ */ jsxs("svg", {
			xmlns: "http://www.w3.org/2000/svg",
			width: "24",
			height: "24",
			viewBox: "0 0 24 24",
			fill: "none",
			stroke: "currentColor",
			strokeWidth: "2",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			children: [
				/* @__PURE__ */ jsx("path", { d: "M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2" }),
				/* @__PURE__ */ jsx("circle", {
					cx: "9",
					cy: "7",
					r: "4"
				}),
				/* @__PURE__ */ jsx("line", {
					x1: "19",
					x2: "19",
					y1: "8",
					y2: "14"
				}),
				/* @__PURE__ */ jsx("line", {
					x1: "22",
					x2: "16",
					y1: "11",
					y2: "11"
				})
			]
		})
	});
});
UserPlusIcon.displayName = "UserPlusIcon";
// src/icons/components/UserRoundCogIcon.tsx
const UserRoundCogIcon = forwardRef((props, ref) => {
	return /* @__PURE__ */ jsx(Icon, {
		...props,
		ref,
		children: /* @__PURE__ */ jsxs("svg", {
			xmlns: "http://www.w3.org/2000/svg",
			width: "24",
			height: "24",
			viewBox: "0 0 24 24",
			fill: "none",
			stroke: "currentColor",
			strokeWidth: "2",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			children: [
				/* @__PURE__ */ jsx("path", { d: "m14.305 19.53.923-.382" }),
				/* @__PURE__ */ jsx("path", { d: "m15.228 16.852-.923-.383" }),
				/* @__PURE__ */ jsx("path", { d: "m16.852 15.228-.383-.923" }),
				/* @__PURE__ */ jsx("path", { d: "m16.852 20.772-.383.924" }),
				/* @__PURE__ */ jsx("path", { d: "m19.148 15.228.383-.923" }),
				/* @__PURE__ */ jsx("path", { d: "m19.53 21.696-.382-.924" }),
				/* @__PURE__ */ jsx("path", { d: "M2 21a8 8 0 0 1 10.434-7.62" }),
				/* @__PURE__ */ jsx("path", { d: "m20.772 16.852.924-.383" }),
				/* @__PURE__ */ jsx("path", { d: "m20.772 19.148.924.383" }),
				/* @__PURE__ */ jsx("circle", {
					cx: "10",
					cy: "8",
					r: "5"
				}),
				/* @__PURE__ */ jsx("circle", {
					cx: "18",
					cy: "18",
					r: "3"
				})
			]
		})
	});
});
UserRoundCogIcon.displayName = "UserRoundCogIcon";
// src/icons/components/UsersIcon.tsx
const UsersIcon = forwardRef((props, ref) => {
	return /* @__PURE__ */ jsx(Icon, {
		...props,
		ref,
		children: /* @__PURE__ */ jsxs("svg", {
			xmlns: "http://www.w3.org/2000/svg",
			width: "24",
			height: "24",
			viewBox: "0 0 24 24",
			fill: "none",
			stroke: "currentColor",
			strokeWidth: "2",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			children: [
				/* @__PURE__ */ jsx("path", { d: "M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2" }),
				/* @__PURE__ */ jsx("circle", {
					cx: "9",
					cy: "7",
					r: "4"
				}),
				/* @__PURE__ */ jsx("path", { d: "M22 21v-2a4 4 0 0 0-3-3.87" }),
				/* @__PURE__ */ jsx("path", { d: "M16 3.13a4 4 0 0 1 0 7.75" })
			]
		})
	});
});
UsersIcon.displayName = "UsersIcon";
// src/icons/components/UserXIcon.tsx
const UserXIcon = forwardRef((props, ref) => {
	return /* @__PURE__ */ jsx(Icon, {
		...props,
		ref,
		children: /* @__PURE__ */ jsxs("svg", {
			xmlns: "http://www.w3.org/2000/svg",
			width: "24",
			height: "24",
			viewBox: "0 0 24 24",
			fill: "none",
			stroke: "currentColor",
			strokeWidth: "2",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			children: [
				/* @__PURE__ */ jsx("path", { d: "M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2" }),
				/* @__PURE__ */ jsx("circle", {
					cx: "9",
					cy: "7",
					r: "4"
				}),
				/* @__PURE__ */ jsx("line", {
					x1: "17",
					x2: "22",
					y1: "8",
					y2: "13"
				}),
				/* @__PURE__ */ jsx("line", {
					x1: "22",
					x2: "17",
					y1: "8",
					y2: "13"
				})
			]
		})
	});
});
UserXIcon.displayName = "UserXIcon";
// src/icons/components/VerticalEllipsisIcon.tsx
const VerticalEllipsisIcon = forwardRef((props, ref) => {
	return /* @__PURE__ */ jsx(Icon, {
		...props,
		ref,
		children: /* @__PURE__ */ jsxs("svg", {
			xmlns: "http://www.w3.org/2000/svg",
			width: "24",
			height: "24",
			viewBox: "0 0 24 24",
			fill: "none",
			stroke: "currentColor",
			strokeWidth: "2",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			children: [
				/* @__PURE__ */ jsx("circle", {
					cx: "12",
					cy: "12",
					r: "1"
				}),
				/* @__PURE__ */ jsx("circle", {
					cx: "12",
					cy: "5",
					r: "1"
				}),
				/* @__PURE__ */ jsx("circle", {
					cx: "12",
					cy: "19",
					r: "1"
				})
			]
		})
	});
});
VerticalEllipsisIcon.displayName = "VerticalEllipsisIcon";
// src/icons/components/VerticalGripIcon.tsx
const VerticalGripIcon = forwardRef((props, ref) => {
	return /* @__PURE__ */ jsx(Icon, {
		...props,
		ref,
		color: "#555555",
		children: /* @__PURE__ */ jsxs("svg", {
			xmlns: "http://www.w3.org/2000/svg",
			width: "24",
			height: "24",
			viewBox: "0 0 24 24",
			fill: "none",
			stroke: "currentColor",
			strokeWidth: "2",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			children: [
				/* @__PURE__ */ jsx("circle", {
					cx: "9",
					cy: "12",
					r: "1"
				}),
				/* @__PURE__ */ jsx("circle", {
					cx: "9",
					cy: "5",
					r: "1"
				}),
				/* @__PURE__ */ jsx("circle", {
					cx: "9",
					cy: "19",
					r: "1"
				}),
				/* @__PURE__ */ jsx("circle", {
					cx: "15",
					cy: "12",
					r: "1"
				}),
				/* @__PURE__ */ jsx("circle", {
					cx: "15",
					cy: "5",
					r: "1"
				}),
				/* @__PURE__ */ jsx("circle", {
					cx: "15",
					cy: "19",
					r: "1"
				})
			]
		})
	});
});
VerticalGripIcon.displayName = "VerticalGripIcon";
// src/icons/components/WrenchIcon.tsx
const WrenchIcon = forwardRef((props, ref) => {
	return /* @__PURE__ */ jsx(Icon, {
		...props,
		ref,
		children: /* @__PURE__ */ jsx("svg", {
			xmlns: "http://www.w3.org/2000/svg",
			width: "24",
			height: "24",
			viewBox: "0 0 24 24",
			fill: "none",
			stroke: "currentColor",
			strokeWidth: "2",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			children: /* @__PURE__ */ jsx("path", { d: "M14.7 6.3a1 1 0 0 0 0 1.4l1.6 1.6a1 1 0 0 0 1.4 0l3.106-3.105c.32-.322.863-.22.983.218a6 6 0 0 1-8.259 7.057l-7.91 7.91a1 1 0 0 1-2.999-3l7.91-7.91a6 6 0 0 1 7.057-8.259c.438.12.54.662.219.984z" })
		})
	});
});
WrenchIcon.displayName = "WrenchIcon";
// src/icons/components/XIcon.tsx
const XIcon = forwardRef((props, ref) => {
	return /* @__PURE__ */ jsx(Icon, {
		...props,
		ref,
		children: /* @__PURE__ */ jsxs("svg", {
			xmlns: "http://www.w3.org/2000/svg",
			width: "24",
			height: "24",
			viewBox: "0 0 24 24",
			fill: "none",
			stroke: "currentColor",
			strokeWidth: "2",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			children: [/* @__PURE__ */ jsx("path", { d: "M18 6 6 18" }), /* @__PURE__ */ jsx("path", { d: "m6 6 12 12" })]
		})
	});
});
XIcon.displayName = "XIcon";
export { NotebookTabsIcon as $, ChevronDownIcon as $t, UnorderListIcon as A, FileDownIcon as At, H1Icon as B, CropIcon as Bt, ShoppingCartIcon as C, GroupIcon as Ct, SearchIcon as D, FileUpIcon as Dt, SendIcon as E, FlaskConicalIcon as Et, QuoteIcon as F, EyeOffIcon as Ft, PresentationIcon as G, CircleQuestionMarkIcon as Gt, RefreshCWIcon as H, ClockIcon as Ht, OrderListIcon as I, EyeIcon as It, PinIcon as J, ChevronUpIcon as Jt, PlusIcon as K, CircleOffIcon as Kt, ItalicIcon as L, ExternalLinkIcon as Lt, UnderlineIcon as M, ShareArrowIcon as Mt, SquareImageIcon as N, MessageCircleIcon as Nt, RotateCCWIcon as O, FileQuestionMarkIcon as Ot, RedoIcon as P, FacebookLogoIcon as Pt, PackageIcon as Q, ChevronLeftIcon as Qt, ImageIcon as R, EarthIcon as Rt, SparklesIcon as S, HeartIcon as St, SettingsIcon as T, GhostIcon as Tt, QRCodeIcon as U, CircleXIcon as Ut, BoldIcon as V, CopyIcon as Vt, PrintIcon as W, CircleUserIcon as Wt, PencilIcon as X, ChevronsLeftIcon as Xt, PhoneIcon as Y, ChevronsRightIcon as Yt, PaperClipIcon as Z, ChevronRightIcon as Zt, StethoscopeIcon as _, ImagesIcon as _t, UserXIcon as a, BriefcaseBusinessIcon as an, MenuIcon as at, SquarePlayIcon as b, HorizontalGripIcon as bt, UserPlusIcon as c, BookAIcon as cn, MailIcon as ct, UserKeyIcon as d, BadgeEuroIcon as dn, ListIcon as dt, CheckIcon as en, NotebookPenIcon as et, UserIcon as f, ArrowRightToLineIcon as fn, LinkIcon as ft, StoreIcon as g, InfoIcon as gt, Trash2Icon as h, Icon as hn, KeyIcon as ht, VerticalEllipsisIcon as i, Calendar1Icon as in, MessageCircleMoreIcon as it, UndoIcon as j, ThumbsUpIcon as jt, RocketIcon as k, FileIcon as kt, UserPenIcon as l, BlocksIcon as ln, LockOpenIcon as lt, TruckIcon as m, ArchiveIcon as mn, KeyRoundIcon as mt, WrenchIcon as n, ChartColumnIncreasingIcon as nn, MonitorIcon as nt, UsersIcon as o, BookOpenIcon as on, MegaphoneIcon as ot, UploadIcon as p, ArrowLeftToLineIcon as pn, LayoutGridIcon as pt, PinOffIcon as q, CircleCheckIcon as qt, VerticalGripIcon as r, CalendarDaysIcon as rn, MessagesSquareIcon as rt, UserRoundCogIcon as s, BookImageIcon as sn, Maximize2Icon as st, XIcon as t, ChartSplineIcon as tn, NewspaperIcon as tt, UserLockIcon as u, BellIcon as un, LockIcon as ut, SquaresSubtractIcon as v, ImagePlusIcon as vt, Share2Icon as w, GraduationCapIcon as wt, SquarePenIcon as x, HorizontalEllipsisIcon as xt, SquarePlusIcon as y, HouseHeartIcon as yt, H2Icon as z, CrossIcon as zt };

//# sourceMappingURL=icons-CPQCRIUN.js.map